<template>
    <a-layout class="futures" :data-theme="userTheme">
        <a-layout-header>
            <PageNav></PageNav>
        </a-layout-header>
        <a-layout-content class="futures_content">
            <!--        热门币种-->
            <div class="hotCoin">
                <img src="@/assets/hot.png" alt="">
                <div class="ticker-scroll">
                    <div class="scroll-content">
                        <div class="item" 
                             v-for="(item,index) in (currency[0] ? currency[0]['currency'] : []).slice(0,15)"
                             :key="'futures-hot-' + (item?.id || index)" 
                             @click="setCurrentCurrency(item)">
                            <span class="coin-name" :class="tableActive === index ? 'font-bold' : ''">
                                {{ item?.symbol || '' }}{{ (currency[0] && currency[0]['legal'] && currency[0]['legal']['symbol']) || 'USDT' }}
                            </span>
                            <span 
                                class="coin-price"
                                :class="{
                                    'color-green': parseFloat(item.change_rate || 0) > 0,
                                    'color-red': parseFloat(item.change_rate || 0) < 0,
                                    'color-gray': parseFloat(item.change_rate || 0) === 0
                                }">
                                {{ $util.thousandSeparator(item.new_price || 0, item.decimals || 2) }}
                            </span>
                            <span 
                                class="coin-change"
                                :class="{
                                    'color-green': parseFloat(item.change_rate || 0) > 0,
                                    'color-red': parseFloat(item.change_rate || 0) < 0,
                                    'color-gray': parseFloat(item.change_rate || 0) === 0
                                }">
                                {{ (parseFloat(item.change_rate || 0) > 0 ? '+' : '') + $util.float(item.change_rate || 0, 2) }}%
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content_head">
                <div class="content_head_left flex flex-column align-center jus-center">
                    <a-trigger trigger="hover" :popup-translate="[100, 10]">
                        <div class="flex flex-row align-center coinSelectBox">
                            <img class="mr-12 coinImage" :src="current?.icon || ''" alt="">
                            <div class="coinInfo">
                                <div class="row flex align-center">
                                    <span class="mr-10 font-bold color-black">
                                        {{current?.symbol || 'BTC'}}{{currency[currencyTab] ? currency[currencyTab]['legal']['symbol'] : ''}}</span>
                                    <div class="caretDown">
                                        <icon-caret-down size="14"/>
                                    </div>
                                </div>
                                <span class="desc">{{ $t('futures.perpetual') }}</span>
                            </div>
                        </div>
                        <template #content>
                            <div class="market-wrap">
                                <a-input class="input" :placeholder="$t('common.search')" v-model="searchVal" allow-clear>
                                    <template #suffix>
                                        <icon-search size="18"/>
                                    </template>
                                </a-input>
                                <!--               -->
                                <div class="market_tab flex align-center">
                                    <div v-for="(item,index) in currency" :key="'tab'+item.id"
                                         class="pad-lr-15 flex align-center jus-center pointer"
                                         :class="subtabActive === 0 ? 'active' : ''"
                                         @click="subtabActive = index">
                                        <span class="font-12 color-gray">{{ getLocalizedTitle(item['title']) }}</span>
                                    </div>
                                </div>
                                <!--                -->
                                <div class="market_tab_main">
                                    <div class="sub_tab flex align-center jus-bet">
                                        <div class="flex align-center pointer">
                                            <span class="font-12 color-gray">{{ $t('futures.contract_target') }}</span>
                                        </div>
                                        <div class="flex align-center jus-end pointer">
                                            <span class="font-12 color-gray">{{ $t('futures.latest_price') }}</span>
                                            <img src="@/assets/images/ranking.svg">
                                        </div>
                                        <div class="flex align-center jus-end pointer">
                                            <span class="font-12 color-gray">{{ $t('futures.twenty_four_hour_change') }}</span>
                                            <img src="@/assets/images/ranking.svg">
                                        </div>
                                    </div>
                                    <a-scrollbar outer-class="scrollbar">
                                        <div class="sub_cell flex align-center jus-bet"
                                             v-for="(item,index) in (searchVal !== '' ? currency[currencyTab]['currency'].filter((item)=>{return item?.symbol?.toLowerCase().includes(searchVal.toLowerCase())}):currency[currencyTab]['currency'])"
                                             :key="'c'+item.id"
                                             @click="setCurrentCurrency(item)">
                                            <div class="flex align-center">
                                                <img class="mr-5" src="@/assets/images/spot/unlike.svg" alt=""
                                                     v-if="like">
                                                <img class="mr-5" src="@/assets/images/spot/like.svg" alt="" v-else>
                                                <span class="font-12 color-black mr-5">{{ item?.symbol || 'BTC' }}</span>
                                                <span class="font-12 color-gray">{{ $t('futures.perpetual') }}</span>
                                            </div>
                                            <div class="flex align-center jus-end">
                                                <span class="font-12"
                                                      :class="{'color-green':item.change_rate >= 0,'color-red':item.change_rate < 0}">
                                                    {{ $util.thousandSeparator(item['new_price'], item.decimals) }}
                                                </span>
                                            </div>
                                            <div class="flex align-center jus-end">
                                                <span class="font-12"
                                                      :class="{'color-green':item.change_rate >= 0,'color-red':item.change_rate < 0}">
                                                    {{ $util.thousandSeparator(item['change_rate'], 2) }}%
                                                </span>
                                            </div>
                                        </div>
                                    </a-scrollbar>
                                </div>
                            </div>
                        </template>
                    </a-trigger>
                </div>
                <div class="content_head_right flex flex-row align-center jus-center">
                    <div class="content_head_right_info">
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-18 font-bold"
                                  :class="{'color-green':(current?.change_rate || 0) >= 0,'color-red':(current?.change_rate || 0) < 0}">
                                {{ $util.thousandSeparator(current?.new_price || 0, current?.decimal || 2) }}
                            </span>
                        </div>
                        <!--          24h涨跌幅-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-12 color-gray pointer">{{ $t('futures.twenty_four_hour_change') }}</span>
                            <span class="font-12 mt-5"
                                  :class="{'color-green':(current?.change_rate || 0) >= 0,'color-red':(current?.change_rate || 0) < 0}">
                                {{ $util.thousandSeparator(current?.change_rate || 0, 2) }}%
                            </span>
                        </div>
                        <!--          标记价格-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                <span class="font-12 color-gray dotted pointer">{{ $t('futures.mark_price') }}</span>
                                <template #content>
                                    <p class="font-12 color-always-white">
                                        {{ $t('futures.mark_price_description') }}</p>
                                </template>
                            </a-tooltip>
                            <span class="font-12 color-black mt-5">
                                {{$util.thousandSeparator(market['p'],current?.decimals || 2)}}
                            </span>
                        </div>
                        <!--          指数价格-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                <span class="font-12 color-gray dotted pointer">{{ $t('futures.index_price') }}</span>
                                <template #content>
                                    <p class="font-12 color-always-white">{{ $t('futures.fair_spot_price') }}</p>
                                </template>
                            </a-tooltip>
                            <span class="font-12 color-black mt-5">
                                {{$util.thousandSeparator(market['i'],current?.decimals || 2)}}
                            </span>
                        </div>
                        <!--          本期资金费率/结算时间-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                <span class="font-12 color-gray dotted pointer">{{ $t('futures.funding_rate_settlement') }}</span>
                                <template #content>
                                    <p class="font-12 color-always-white flex jus-bet">{{ $t('futures.current_settlement_time') }}：<strong>
<!--                                        9月24日 0时0分(04:30:20)-->
                                        {{ $util.dateFormatter(market['T'], 'm月d日 h時i分', 2) }}
                                    </strong></p>
                                    <p class="font-12 color-always-white flex jus-bet">{{ $t('futures.current_funding_rate') }}({{market['r'] >0 ? $t('futures.long_position_pays'):$t('futures.short_position_pays')}})：<strong>{{$util.float(market['r'] * 100)}}%</strong>
                                    </p>
                                    <p class="font-14 color-always-white font-bold">{{ $t('futures.funding_rate_explanation') }}</p>
                                    <p class="font-12 color-always-white">
                                        {{ $t('futures.funding_rate_purpose') }}</p>
                                    <p class="font-12 color-always-white">
                                        {{ $t('futures.funding_rate_settlement_description') }}</p>
                                    <p class="font-12 color-always-white">{{ $t('futures.funding_fee_formula') }}</p>
                                </template>
                            </a-tooltip>
                            <span class="font-12 color-black mt-5">{{$util.thousandSeparator(market['r'] * 100)}}%/{{timeInt}}</span>
                        </div>
                        <!--          24H最高价-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-12 color-gray">{{ $t('futures.twenty_four_hour_high') }}</span>
                            <span class="font-12 color-black mt-5">
                                 {{ $util.thousandSeparator(current?.high_price || 0, current?.decimals || 2) }}
                            </span>
                        </div>
                        <!--          24H最低价-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-12 color-gray">{{ $t('futures.twenty_four_hour_low') }}</span>
                            <span class="font-12 color-black mt-5">
                                {{ $util.thousandSeparator(current?.low_price || 0, current?.decimals || 2) }}
                            </span>
                        </div>
                        <!--          24H成交量（BTC）-->
                        <div class="flex flex-column align-start pad-lr-15">
                                                            <span class="font-12 color-gray">{{ $t('futures.twenty_four_hour_volume') }}（{{ current?.symbol || 'BTC' }}）</span>
                            <span class="font-12 color-black mt-5">
                                {{ $util.thousandSeparator(current?.quantity || 0, current?.decimals || 2) }}
                            </span>
                        </div>
                        <!--          24H成交额（USDT）-->
                        <div class="flex flex-column align-start pad-lr-15">
                            <span class="font-12 color-gray">{{ $t('futures.twenty_four_hour_turnover') }}（USDT）</span>
                            <span class="font-12 color-black mt-5">
                                {{ $util.thousandSeparator(current?.quota || 0, current?.decimals || 2) }}
                            </span>
                        </div>
                    </div>
                    <div class="rightButtons">
                        <a-tooltip position="top" background-color="var(--tooltip-bg)">
                            <div class="item" @click="aboutCoinShow">
                                <icon-bookmark size="16"/>
                            </div>
                            <template #content>
                                <p class="font-12 color-always-white">{{ coinName }}USDT {{ $t('futures.introduction') }}</p>
                            </template>
                        </a-tooltip>
                        <a-tooltip position="top" background-color="var(--tooltip-bg)">
                            <div class="item" @click="settingDrawer = true">
                                <icon-settings size="16"/>
                            </div>
                            <template #content>
                                <p class="font-12 color-always-white">{{ $t('futures.preferences') }}</p>
                            </template>
                        </a-tooltip>
                    </div>
                </div>
            </div>
            <div class="content_main mt-10 flex jus-bet">
                <!--  -->
                <div class="content_main_left">
                    <div class="left_top flex flex-row jus-bet">
                        <!--            chart-->
                        <div class="block_kline">
                            <!--              table-->
                            <div class="kline_table"></div>
                            <!--              kline box-->
                            <div class="kline_box flex align-center jus-center">
                                <div class="chartBox" id="chartBox" style="width: 100%;height:100%"></div>
                            </div>
                        </div>
                        <!--      委托列表/实时成交      -->
                        <div class="block_list">
                            <a-tabs default-active-key="1">
                                <a-tab-pane key="1" :title="$t('futures.order_list')">
                                    <div class="_top pad-lr-15 flex flex-row align-center jus-bet">
                                        <div class="flex align-center listTagGroup">
                                            <a-tooltip :content="$t('futures.buy_sell_panel')" position="top"
                                                       background-color="var(--tooltip-bg)">
                                                <div class="item flex align-center jus-center"
                                                     :class="listType == 0 ? 'item-active' : ''" @click="listType = 0">
                                                    <img src="@/assets/images/cut-top-bottom.svg">
                                                </div>
                                            </a-tooltip>
                                            <a-tooltip :content="$t('futures.buy_panel')" position="top"
                                                       background-color="var(--tooltip-bg)">
                                                <div class="item flex align-center jus-center"
                                                     :class="listType == 1 ? 'item-active' : ''" @click="listType = 1">
                                                    <img src="@/assets/images/cut-buy.svg">
                                                </div>
                                            </a-tooltip>
                                            <a-tooltip :content="$t('futures.sell_panel')" position="top"
                                                       background-color="var(--tooltip-bg)">
                                                <div class="item flex align-center jus-center"
                                                     :class="listType == 2 ? 'item-active' : ''" @click="listType = 2">
                                                    <img src="@/assets/images/cut-ask.svg">
                                                </div>
                                            </a-tooltip>
                                        </div>
                                        <a-dropdown trigger="hover" @select="numSelect">
                                            <div class="flex align-center jus-end numSelect">
                                                <span class="mr-5">{{ decimal }}</span>
                                                <icon-caret-down/>
                                            </div>
                                            <template #content>
                                                <a-doption>0.000001</a-doption>
                                                <a-doption>0.00001</a-doption>
                                                <a-doption>0.0001</a-doption>
                                            </template>
                                        </a-dropdown>
                                    </div>
                                    <!--                -->
                                    <div class="list-main">
                                        <div class="down_group group_box" v-if="listType == 0 || listType == 2">
                                            <div class="_cell flex align-center jus-bet" type="title">
                                                <span class="font-12 color-gray">{{ $t('futures.price') }}</span>
                                                <span class="font-12 color-gray">{{ $t('futures.quantity') }} ({{ current?.symbol || 'BTC' }})</span>
                                                <span class="font-12 color-gray">{{ $t('futures.total') }} (USDT)</span>
                                            </div>
                                            <div v-if="listType === 2">
                                                <div class="_cell flex align-center jus-bet" type="title">
                                                    <span class="font-12 color-gray">{{ $t('futures.latest_price') }}</span>
                                                    <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                                        <span class="font-12 color-gray pointer dotted">{{ $t('futures.mark_price_short') }}</span>
                                                        <template #content>
                                                            <span class="font-12 color-always-white">
                                                                标记价格用于结算盈亏和触发强制减仓。标记价格可能会偏离市场最新价格，以防因市场被恶意操纵造成损失。
                                                            </span>
                                                        </template>
                                                    </a-tooltip>
                                                </div>
                                                <div class="_cell flex align-center jus-bet mb-5">
                                                     <span class="font-16 color-green font-bold">
                                                        {{ $util.thousandSeparator(current?.new_price || 0,current?.decimals || 2) }}
                                                         <!--                                                        <icon-arrow-up style="margin-top: 1px"/>-->
                                                    </span>
                                                    <span class="font-16 color-gray font-bold">
                                                        {{ $util.thousandSeparator(market['p'],current?.decimals || 2) }}
                                                    </span>
                                                </div>
                                            </div>
                                            <!--                      -->
                                            <a-scrollbar :class="listType == 0 ? 'minList' : 'priceDownList'">
                                                <div class="_cell flex align-center jus-bet pointer hover-bg"
                                                     v-for="(item,index) in bids"
                                                     :key="'bids'+index">
                                                    <span class="font-12 color-red">{{ $util.thousandSeparator(item[0],current?.decimals || 2) }}</span>
                                                    <span class="font-12 color-black">{{ item[1] }}</span>
                                                    <span class="font-12 color-black">{{ $util.thousandSeparator(item[0] * item[1],2) }}</span>
                                                    <!-- 背景盒子     -->
                                                    <div class="_cell_bg red_bg"
                                                         :style="{'--width':item[3] * 100 + '%' }"></div>
                                                </div>
                                            </a-scrollbar>
                                        </div>
                                        <div class="up_group group_box" v-if="listType == 1 || listType == 0">
                                            <div>
                                                <div class="_cell flex align-center jus-bet" type="title">
                                                    <span class="font-12 color-gray">{{ $t('futures.latest_price') }}</span>
                                                    <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                                        <span class="font-12 color-gray pointer dotted">{{ $t('futures.mark_price_short') }}</span>
                                                        <template #content>
                                                            <span class="font-12 color-always-white">
                                                                标记价格用于结算盈亏和触发强制减仓。标记价格可能会偏离市场最新价格，以防因市场被恶意操纵造成损失。
                                                            </span>
                                                        </template>
                                                    </a-tooltip>
                                                </div>
                                                <div class="_cell flex align-center jus-bet mb-5">
                                                    <span class="font-16 color-green font-bold">
                                                        {{ $util.thousandSeparator(current?.new_price || 0,current?.decimals || 2) }}
<!--                                                        <icon-arrow-up style="margin-top: 1px"/>-->
                                                    </span>
                                                    <span class="font-16 color-gray font-bold">
                                                        {{ $util.thousandSeparator(market['p'],current?.decimals || 2) }}
                                                    </span>
                                                </div>
                                            </div>
                                            <!--                      -->
                                            <a-scrollbar :class="listType === 0 ? 'minList' : 'maxList'">
                                                <div class="_cell flex align-center jus-bet pointer hover-bg"
                                                     v-for="(item,index) in asks"
                                                     :key="'a'+index">
                                                    <span class="font-12 color-green">{{ $util.thousandSeparator(item[0],current?.decimals || 2) }}</span>
                                                    <span class="font-12 color-green">{{ item[1] }}</span>
                                                    <span class="font-12 color-green">{{ $util.thousandSeparator(item[0] * item[1],2) }}</span>
                                                    <!-- 背景盒子     -->
                                                    <div class="_cell_bg red_bg"
                                                         :style="{'--width':item[3] * 100 + '%' }"></div>
                                                </div>
                                            </a-scrollbar>
                                        </div>
                                    </div>
                                </a-tab-pane>
                                <a-tab-pane key="2" :title="$t('futures.real_time_trades')">
                                    <div class="list-main">
                                        <div class="down_group group_box">
                                            <div class="_cell flex align-center jus-bet" type="title">
                                                <span class="font-12 color-gray">{{ $t('futures.price') }}</span>
                                                <span class="font-12 color-gray">{{ $t('futures.quantity') }} ({{ coinName }})</span>
                                                <span class="font-12 color-gray">{{ $t('futures.time') }}</span>
                                            </div>
                                            <a-scrollbar class="scrollbar">
                                                <!--                      -->
                                                <div class="_cell flex align-center jus-bet pointer hover-bg"
                                                     v-for="(item,index) in trades"
                                                     :key="'t'+index">
                                                      <span class="font-12" :class="item.m ? 'color-red' : 'color-green'">
                                                          {{item.price }}
                                                      </span>
                                                    <span class="font-12 color-black">{{ item.vol }}</span>
                                                    <span class="font-12 color-black">{{ item.time }}</span>
                                                    <!-- 背景盒子     -->
                                                    <div class="_cell_bg"
                                                         :class="index % 2 === 0 ? 'red_bg' : 'green-bg'"
                                                         :style="{'--width':item.price * 100 + '%' }"></div>
                                                </div>
                                            </a-scrollbar>
                                        </div>
                                    </div>
                                </a-tab-pane>
                            </a-tabs>
                        </div>
                    </div>
                    <div class="left_bottom">
                        <!--   持仓/当前委托... -->
                        <div class="left_bottom_card">
                            <a-tabs animation default-active-key="1" @change="tabChange">
                                <a-tab-pane key="1" :title="`${$t('futures.positions')}(${isLogin ? position.position.length : ''})`">
                                    <a-scrollbar style="height:306px;overflow: auto;">
                                        <!--   table    -->
                                        <div class="top_table flex flex-row align-center" type="first">
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.contract') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.position_direction') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <a-tooltip type="subtip" position="bottom"
                                                           background-color="var(--tooltip-bg)">
                                                    <span class="font-12 color-gray dotted pointer">{{ $t('futures.position_closeable') }}</span>
                                                    <template #content>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.position_size') }}
                                                        </p>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.closeable_amount') }}
                                                        </p>
                                                    </template>
                                                </a-tooltip>
                                            </div>
                                            <div class="tableItem">
                                                <a-tooltip type="subtip" position="bottom"
                                                           background-color="var(--tooltip-bg)">
                                                    <span class="font-12 color-gray dotted pointer">{{ $t('futures.average_price') }}</span>
                                                    <template #content>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.average_open_price') }}
                                                        </p>
                                                    </template>
                                                </a-tooltip>
                                            </div>
<!--                                            <div class="tableItem">-->
<!--                                                <a-tooltip type="subtip" position="bottom"-->
<!--                                                           background-color="var(&#45;&#45;tooltip-bg)">-->
<!--                                                    <span class="font-12 color-gray dotted pointer">标记价格</span>-->
<!--                                                    <template #content>-->
<!--                                                        <p class="font-12 color-always-white">-->
<!--                                                            标记价格用于结算盈亏和触发强制减仓。标记价格可能会偏离市场最新价格，以防因市场被恶意操纵造成损失。-->
<!--                                                        </p>-->
<!--                                                        <p class="font-12 color-always-white">-->
<!--                                                            标记价格可能会偏离市场最新价格，以防因市场被恶意操纵造成损失。-->
<!--                                                        </p>-->
<!--                                                    </template>-->
<!--                                                </a-tooltip>-->
<!--                                            </div>-->
                                            <div class="tableItem">
                                                <a-tooltip type="subtip" position="bottom"
                                                           background-color="var(--tooltip-bg)">
                                                    <span class="font-12 color-gray dotted pointer">{{ $t('futures.estimated_liquidation_price') }}</span>
                                                    <template #content>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.liquidation_price_description') }}</p>
                                                    </template>
                                                </a-tooltip>
                                            </div>
                                            <div class="tableItem">
                                                <a-tooltip type="subtip" position="bottom"
                                                           background-color="var(--tooltip-bg)">
                                                    <span class="font-12 color-gray dotted pointer">{{ $t('futures.margin') }}</span>
                                                    <template #content>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.collateral_assets_description') }}
                                                        </p>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.collateral_assets_description') }}
                                                        </p>
                                                    </template>
                                                </a-tooltip>
                                            </div>
                                            <div class="tableItem">
                                                <a-tooltip type="subtip" position="bottom"
                                                           background-color="var(--tooltip-bg)">
                                                    <span class="font-12 color-gray dotted pointer">{{ $t('futures.margin_ratio') }}</span>
                                                    <template #content>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.margin_rate_description') }}
                                                            {{ $t('futures.forced_liquidation_threshold') }}
                                                        </p>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.forced_liquidation_condition') }}
                                                        </p>
                                                    </template>
                                                </a-tooltip>
                                            </div>
                                            <div class="tableItem" style="width: 150px">
                                                <a-tooltip type="subtip" position="bottom"
                                                           background-color="var(--tooltip-bg)">
                                                    <span
                                                            class="font-12 color-gray dotted pointer">{{ $t('futures.unrealized_pnl_return_rate') }}</span>
                                                    <template #content>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.long_profit_formula') }}
                                                        </p>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.short_profit_formula') }}
                                                        </p>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.return_rate_formula') }}
                                                        </p>
                                                    </template>
                                                </a-tooltip>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.realized_pnl') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.operation') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <a-tooltip type="subtip" position="bottom"
                                                           background-color="var(--tooltip-bg)">
                                                    <span class="font-12 color-gray dotted pointer">{{ $t('futures.take_profit_stop_loss_price') }}</span>
                                                    <template #content>
                                                        <p class="font-12 color-always-white">
                                                            {{ $t('futures.take_profit_stop_loss_description') }}
                                                        </p>
                                                    </template>
                                                </a-tooltip>
                                            </div>
                                        </div>
                                        <notlog style="height: calc(100% - 55px)" v-if="!isLogin"></notlog>
                                        <notdate v-if="isLogin && position.position.length <= 0" :msg="$t('futures.no_position_data')"></notdate>
                                        <div class="listWarp" type="first">
                                            <a-scrollbar outer-class="listWarp">
                                                <!--  列表项 -->
                                                <div class="cell flex flex-row align-center" v-for="(item,index) in position.position" :key="'p'+item.id">
                                                    <!--  合约 -->
                                                    <div class="cellItem">
                                                        <span class="coinBefore bg-red"></span>
                                                        <span class="coin color-black">{{item?.symbol || 'BTC'}}USDT</span>
                                                        <a-tag color="var(--opacity-gray)">
                                                            <span class="color-black">{{item?.margin_type === 1 ? $t('futures.position_cross_margin'):$t('futures.position_isolated_margin')}}{{item?.muilt || 0}}X</span>
                                                        </a-tag>
                                                    </div>
                                                    <!--  持仓方向 -->
                                                    <div class="cellItem">
                                                        <a-tag color="var(--opacity-sell)">
                                                            <span class="color-red" :class="{'color-red':item['direction']===2,'color-green':item['direction']!==2}">{{item['direction'] === 1 ? $t('futures.open_long'):$t('futures.open_short')}}</span>
                                                        </a-tag>
                                                    </div>
                                                    <!--  仓位/开平 -->
                                                    <div class="cellItem">
                                                        <span class="color-red">
                                                            {{$util.float(item?.amount || 0)}}/{{$util.thousandSeparator((item?.amount || 0) - (item?.close || 0),8)}} {{item?.symbol || 'BTC'}}
                                                        </span>
                                                    </div>
                                                    <!--  持仓均价 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">
                                                            {{$util.thousandSeparator(item['price'])}}
                                                        </span>
                                                    </div>
                                                    <!--  标记价格 -->
<!--                                                    <div class="cellItem">-->
<!--                                                        <span class="color-black">-->
<!--                                                            {{$util.thousandSeparator(current['new_price'],current['decimals'])}}-->
<!--                                                        </span>-->
<!--                                                    </div>-->
                                                    <!--  预估强平价格 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">
                                                            {{$util.thousandSeparator(item['stopPrice'],current?.decimals || 2)}}
                                                        </span>
                                                    </div>
                                                    <!--  保证金 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">
                                                            {{$util.float(item['margin'])}}
                                                        </span>
                                                    </div>
                                                    <!--  保证金率 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{item['mr']}}%</span>
                                                    </div>
                                                    <!--  持仓中盈亏/回报率 -->
                                                    <div class="cellItem" style="width: 150px">
                                                        <span class="mr-5" :class="{'color-red':item['p'] <= 0 ,'color-green':item['p']>0}">{{item['p']}}</span>/
                                                        <a-tag color="var(--opacity-sell)">
                                                            <span :class="{'color-red':item['p'] <= 0 ,'color-green':item['p']>0}">{{item['rate']}}%</span>
                                                        </a-tag>
                                                    </div>
                                                    <!--  已实现盈亏 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{$util.thousandSeparator(item['profit'])}} USDT</span>
                                                    </div>
                                                    <div class="cellItem">
                                                        <span class="color-primary cursor mr-5"
                                                              @click="pindex = index;closePotion = true">{{ $t('futures.close_position') }}</span>
                                                        <span class="color-primary cursor" @click="pindex = index;flashClose = true">{{ $t('futures.flash_close') }}</span>
                                                    </div>
                                                    <div class="cellItem">
                                                        <span class="mr-5 color-black">
                                                            {{item['winPrice'] > 0 ? $util.thousandSeparator(item['winPrice']):'--'}}/{{item['losePrice'] > 0 ? $util.thousandSeparator(item['losePrice']):'--'}}
                                                        </span>
                                                        <icon-edit class="cursor color-black"
                                                                   @click="pindex = index;profitLossPop = true"/>
                                                    </div>
                                                </div>
                                            </a-scrollbar>
                                        </div>
                                    </a-scrollbar>
                                </a-tab-pane>
                                <a-tab-pane key="2" :title="`${$t('futures.current_orders')}(${isLogin && position.entrust ? position.entrust.length : ''})`">
                                    <a-scrollbar style="height:306px;overflow: auto;">
                                        <!--   table    -->
                                        <div class="top_table flex flex-row align-center" type="tab2">
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.contract') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.direction') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.type') }}</span>
                                            </div>
                                            <div class="tableItem" style="width: 230px !important;">
                                                <span class="font-12 color-gray">{{ $t('futures.avg_price_order_price') }}</span>
                                            </div>
                                            <div class="tableItem" >
                                                <span class="font-12 color-gray">{{ $t('futures.filled_amount_order_amount') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.completion') }}</span>
                                            </div>
                                            <a-tooltip type="subtip" position="bottom"
                                                       background-color="var(--tooltip-bg)">
                                                <div class="tableItem">
                                                    <span class="font-12 color-gray dotted pointer">{{ $t('futures.take_profit_stop_loss_price') }}</span>
                                                </div>
                                                <template #content>
                                                                                                            <p class="font-12 color-always-white">
                                                            {{ $t('futures.auto_close_on_trigger') }}
                                                        </p>
                                                </template>
                                            </a-tooltip>
                                            <div class="tableItem" style="width: 194px !important;">
                                                <span class="font-12 color-gray">时间</span>
                                            </div>
                                            <div class="tableItem" style="justify-content: flex-end;text-align: right">
                                                <span class="font-12 color-gray">操作</span>
                                            </div>
                                        </div>
                                        <div class="listWarp" type="tab2">
                                            <notlog style="height: calc(100% - 55px)" v-if="!isLogin"></notlog>
                                            <notdate v-if="isLogin && position.entrust.length <= 0" :msg="$t('futures.no_order_data')"></notdate>
                                            <a-scrollbar outer-class="listWarp">
                                                <!--  列表项 -->
                                                <div class="cell flex flex-row align-center" v-for="(item,index) in position.entrust" :key="'e'+item.id">
                                                    <!--  合约 -->
                                                    <div class="cellItem">
                                                        <span class="coin color-black">{{item?.symbol || 'BTC'}}USDT</span>
                                                    </div>
                                                    <!--  方向 -->
                                                    <div class="cellItem">
                                                        <a-tag color="var(--opacity-sell)">
                                                            <span class="color-red" :class="{'color-red':item['direction']===2,'color-green':item['direction']!==2}">{{item['direction'] === 1 ? $t('futures.open_long') : $t('futures.open_short')}}</span>
                                                        </a-tag>
                                                    </div>
                                                    <!--  类型 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{ $t('futures.limit_order') }}</span>
                                                    </div>
                                                    <!--  成交均价/委托价格 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{$util.float(item.t_price)}}/{{$util.thousandSeparator(item.price,item.decimals)}}</span>
                                                    </div>
                                                    <!--  成交数量/委托数量 -->
                                                    <div class="cellItem" style="width: 120px">
                                                        <span class="color-black">0.00/{{$util.float(item.amount)}}</span>
                                                    </div>
                                                    <!--  完成度 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">0%</span>
                                                    </div>
                                                    <!--  止盈价/止损价 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{$util.float(item.winPrice)}}/{{$util.float(item.losePrice)}}</span>
                                                    </div>

<!--                                                    <div class="cellItem">-->
<!--                                                        <span class="color-black" v-if="i === 1">&#45;&#45;/&#45;&#45;</span>-->
<!--                                                        <span class="color-black" v-if="i != 1">0.6500/0.6990</span>-->
<!--                                                    </div>-->
                                                    <!--  时间 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{item.created_at}}</span>
                                                    </div>
                                                    <!--  撤单 -->
                                                    <div class="cellItem" style="text-align: left;justify-content: flex-start">
                                                        <span class="color-primary cursor"
                                                              @click="pindex=index;wdOrder = true">{{ $t('futures.cancel_order') }}</span>
                                                    </div>
                                                </div>
                                            </a-scrollbar>
                                        </div>
                                    </a-scrollbar>
                                </a-tab-pane>
                                <a-tab-pane key="3" :title="`${$t('futures.planned_orders')}(${isLogin && position.entrustP ? position.entrustP.length : ''})`">
                                    <a-scrollbar style="height:306px;overflow: auto;">
                                        <!--   table    -->
                                        <div class="top_table flex flex-row align-center" type="tab3">
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.contract') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.order_type') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.trigger_price') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.order_price') }}</span>
                                            </div>
                                            <div class="tableItem" style="width: 186px">
                                                <span class="font-12 color-gray">{{ $t('futures.order_amount') }}</span>
                                            </div>
<!--                                            <div class="tableItem">-->
<!--                                                <span class="font-12 color-gray">类型</span>-->
<!--                                            </div>-->
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.submit_time') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.expire_time') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.operation') }}</span>
                                            </div>
                                        </div>
                                        <div class="listWarp" type="tab3">
                                            <notlog style="height: calc(100% - 55px)" v-if="!isLogin"></notlog>
                                            <notdate v-if="isLogin && position.entrustP.length <= 0" :msg="$t('futures.no_order_data')"></notdate>
                                            <a-scrollbar outer-class="listWarp">
                                                <!--  列表项 -->
                                                <div class="cell flex flex-row align-center" v-for="(item,index) in position.entrustP" :key="'ep'+item.id">
                                                    <!--  合约 -->
                                                    <div class="cellItem">
                                                        <span class="coin color-black">{{item?.symbol || 'BTC'}}USDT</span>
                                                    </div>
                                                    <!--  方向 -->
                                                    <div class="cellItem" style="width: 143px !important;">
                                                        <a-tag color="var(--opacity-sell)">
                                                            <span class="color-red" v-if="item.type === 1">{{ $t('futures.open_long') }}</span>
                                                            <span class="color-red" v-if="item.type === 2">{{ $t('futures.open_short') }}</span>
                                                            <span class="color-red" v-if="item.type === 3">{{ $t('futures.close_long') }}</span>
                                                            <span class="color-red" v-if="item.type === 4">{{ $t('futures.close_short') }}</span>
                                                            <span class="color-red" v-if="item.type === 5">{{ $t('futures.take_profit') }}</span>
                                                            <span class="color-red" v-if="item.type === 6">{{ $t('futures.stop_loss') }}</span>
                                                        </a-tag>
                                                    </div>
                                                    <!--  触发价格 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{$util.float(item.wprice)}}</span>
                                                    </div>
                                                    <!--  委托价格 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">
                                                            {{item.price === '' ? $util.float(item.wprice):$util.float(item.wprice)}}
                                                        </span>
                                                    </div>
                                                    <!--  委托数量 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{$util.float(item?.amount || 0)}} {{item?.symbol || 'BTC'}}</span>
                                                    </div>
                                                    <!--  提交时间 -->
                                                    <div class="cellItem" style="width: 143px !important;">
                                                        <span class="color-black">{{item.created_at}}</span>
                                                    </div>
                                                    <!--  过期时间 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{$util.getDateAddDay(item.created_at,30)}} 00:00:00</span>
                                                    </div>
                                                    <!--  撤单 -->
                                                    <div class="cellItem">
                                                        <span class="color-primary cursor"
                                                              @click="pindex=index;wdOrder = true">{{ $t('futures.cancel_order') }}</span>
                                                    </div>
                                                </div>
                                            </a-scrollbar>
                                        </div>
                                        <notlog style="height: calc(100% - 55px)" v-if="false"></notlog>
                                    </a-scrollbar>
                                </a-tab-pane>
                                <a-tab-pane key="4" :title="$t('futures.order_history')">
                                    <a-scrollbar style="height:306px;overflow: auto;">
                                        <!--   table    -->
                                        <div class="top_table flex flex-row align-center" type="tab4">
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.contract') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.direction') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.type') }}</span>
                                            </div>
                                            <div class="tableItem" style="width: 195px">
                                                <span class="font-12 color-gray">{{ $t('futures.avg_price_order_price') }}</span>
                                            </div>
                                            <div class="tableItem" style="width: 195px">
                                                <span class="font-12 color-gray">{{ $t('futures.filled_amount_order_amount') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.pnl_usdt') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.fee_usdt') }}</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.status') }}</span>
                                            </div>
                                            <div class="tableItem" style="width: 164px">
                                                <span class="font-12 color-gray">{{ $t('futures.time') }}</span>
                                            </div>
                                            <div class="tableItem" style="justify-content: flex-end;text-align: right">
                                                <span class="font-12 color-gray">{{ $t('futures.operation') }}</span>
                                            </div>
                                        </div>
                                        <div class="listWarp" type="tab4">
                                            <notlog style="height: calc(100% - 55px)" v-if="!isLogin"></notlog>
                                            <notdate v-if="isLogin && history.history && history.history.list <= 0" :msg="$t('futures.no_order_data')"></notdate>
                                            <a-scrollbar outer-class="listWarp">
                                                <!--  列表项 -->
                                                <div class="cell flex flex-row align-center" v-for="(item,index) in (history.history ? history.history.list :[])" :key="'history'+item.id">
                                                    <!--  合约 -->
                                                    <div class="cellItem">
                                                        <span class="coin color-black">{{item?.symbol || 'BTC'}}USDT</span>
                                                    </div>
                                                    <!--  方向 -->
                                                    <div class="cellItem">
                                                        <a-tag color="var(--opacity-sell)">
                                                            <span class="color-red" v-if="item.type === 1">{{ $t('futures.open_long') }}</span>
                                                            <span class="color-red" v-if="item.type === 2">{{ $t('futures.open_short') }}</span>
                                                            <span class="color-red" v-if="item.type === 3">{{ $t('futures.close_long') }}</span>
                                                            <span class="color-red" v-if="item.type === 4">{{ $t('futures.close_short') }}</span>
                                                            <span class="color-red" v-if="item.type === 5">{{ $t('futures.take_profit') }}</span>
                                                            <span class="color-red" v-if="item.type === 6">{{ $t('futures.stop_loss') }}</span>
                                                        </a-tag>
                                                    </div>
                                                    <!--  类型 -->
                                                    <div class="cellItem">
                                                        <span class="color-black" v-if="item.ttype === 1">{{ $t('futures.market_order') }}</span>
                                                        <span class="color-black" v-if="item.ttype === 2">{{ $t('futures.limit_order') }}</span>
                                                        <span class="color-black" v-if="item.ttype === 3">{{ $t('futures.conditional_order') }}</span>
                                                    </div>
                                                    <!--  成交均价/委托价格 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">
                                                            {{$util.thousandSeparator(item?.t_price || 0,2)}}/{{$util.thousandSeparator(item?.price || 0,2)}}
                                                        </span>
                                                    </div>
                                                    <!--  成交数量/委托数量 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">
                                                            {{$util.float(item?.amount || 0)}}/{{$util.float(item?.amount || 0)}}
                                                        </span>
                                                    </div>
                                                    <!--  盈亏 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{$util.float(item?.profit || 0)}}</span>
                                                    </div>
                                                    <!--  手续费 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{$util.float(item?.charge || 0)}}</span>
                                                    </div>
                                                    <!--  状态 -->
                                                    <div class="cellItem">
                                                        <span class="color-black" v-if="item?.status === 2 || item?.status === 'completed' || item?.status === 'filled'">{{ $t('futures.completely_filled') }}</span>
                                                        <span class="color-black" v-if="item?.status === 1 || item?.status === 'pending' || item?.status === 'open'">{{ $t('futures.pending') }}</span>
                                                        <span class="color-black" v-if="item?.status === 3 || item?.status === 'cancelled' || item?.status === 'canceled'">{{ $t('futures.cancelled') }}</span>
                                                    </div>
                                                    <!--  时间 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{item?.created_at || ''}}</span>
                                                    </div>
                                                    <!--  订单详情 -->
                                                    <div class="cellItem" style="justify-content: flex-start;text-align: left">
                                                        <span class="color-primary cursor"
                                                              @click="pindex=index;orderInfoPopup = true">{{ $t('futures.details') }}</span>
                                                    </div>
                                                </div>
                                            </a-scrollbar>
                                        </div>
                                        <notlog style="height: calc(100% - 55px)" v-if="false"></notlog>
                                    </a-scrollbar>
                                </a-tab-pane>
                                <a-tab-pane key="5" :title="$t('futures.pnl_record')">
                                    <a-scrollbar style="height:306px;overflow: auto;">
                                        <!--   table    -->
                                        <div class="top_table flex flex-row align-center" type="tab5">
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">{{ $t('futures.contract') }}</span>
                                            </div>
                                            <div class="tableItem" style="width: 120px !important;">
                                                <span class="font-12 color-gray">{{ $t('futures.direction') }}</span>
                                            </div>
                                            <div class="tableItem" style="width: 120px !important;">
                                                <span class="font-12 color-gray">{{ $t('futures.open_price') }}</span>
                                            </div>
                                            <div class="tableItem" style="width: 120px !important;">
                                                <span class="font-12 color-gray">{{ $t('futures.close_price') }}</span>
                                            </div>
                                            <div class="tableItem" style="width: 120px !important;">
                                                <span class="font-12 color-gray">{{ $t('futures.position_amount') }}</span>
                                            </div>
                                            <a-tooltip type="subtip" position="bottom"
                                                       background-color="var(--tooltip-bg)">
                                                <div class="tableItem" style="width: 120px !important;">
                                                    <span class="font-12 color-gray pointer dotted">{{ $t('futures.realized_pnl') }}</span>
                                                </div>
                                                <template #content>
                                                                                                            <p class="font-12 color-always-white">
                                                            {{ $t('futures.total_profit_loss_description') }}
                                                        </p>
                                                </template>
                                            </a-tooltip>
<!--                                            <div class="tableItem">-->
<!--                                                <span class="font-12 color-gray">分润</span>-->
<!--                                            </div>-->
                                            <a-tooltip type="subtip" position="bottom"
                                                       background-color="var(--tooltip-bg)">
                                                <div class="tableItem" style="width: 120px !important;">
                                                    <span class="font-12 color-gray pointer dotted">{{ $t('futures.fee_usdt') }}</span>
                                                </div>
                                                <template #content>
                                                                                                            <p class="font-12 color-always-white">
                                                            {{ $t('futures.total_fees') }}
                                                        </p>
                                                </template>
                                            </a-tooltip>
                                            <a-tooltip type="subtip" position="bottom"
                                                       background-color="var(--tooltip-bg)">
                                                <div class="tableItem" style="width: 120px !important;">
                                                    <span class="font-12 color-gray pointer dotted">{{ $t('futures.funding_fee') }}</span>
                                                </div>
                                                <template #content>
                                                                                                            <p class="font-12 color-always-white">
                                                            {{ $t('futures.total_funding_fees') }}
                                                        </p>
                                                </template>
                                            </a-tooltip>
<!--                                            <a-tooltip type="subtip" position="bottom"-->
<!--                                                       background-color="var(&#45;&#45;tooltip-bg)">-->
<!--                                                <div class="tableItem">-->
<!--                                                    <span class="font-12 color-gray pointer dotted">仓位盈亏</span>-->
<!--                                                </div>-->
<!--                                                <template #content>-->
<!--                                                    <p class="font-12 color-always-white">-->
<!--                                                        仓位盈亏为仓位每次平仓的仓位盈亏之和，平仓盈亏根据-->
<!--                                                        平仓前的持仓均价和平仓均价计算得出-->
<!--                                                    </p>-->
<!--                                                </template>-->
<!--                                            </a-tooltip>-->
<!--                                            <div class="tableItem">-->
<!--                                                <span class="font-12 color-gray">分摊</span>-->
<!--                                            </div>-->
                                            <div class="tableItem" style="width: 120px !important;">
                                                <span class="font-12 color-gray">{{ $t('futures.close_time') }}</span>
                                            </div>
                                        </div>
                                        <div class="listWarp" type="tab5">
                                            <a-scrollbar outer-class="listWarp">
                                                <!--  列表项 -->
                                                <div class="cell flex flex-row align-center" v-for="(item,index) in (history.profit ? history.profit.list : [])" :key="'profit'+item.id">
                                                    <!--  合约 -->
                                                    <div class="cellItem">
                                                        <span class="coinBefore bg-red"></span>
                                                        <span class="coin color-black">{{item?.symbol || 'BTC'}}USDT</span>
                                                        <a-tag color="var(--opacity-gray)">
                                                            <span class="color-black">{{item?.margin_type === 1 ? $t('futures.cross_margin') : $t('futures.isolated_margin')}}{{item?.muilt || 0}}X</span>
                                                        </a-tag>
                                                    </div>
                                                    <div class="cellItem" style="width: 120px !important;">
                                                        <a-tag color="var(--opacity-sell)" v-if="item.direction === 1">
                                                            <span class="color-red">{{ $t('futures.long') }}</span>
                                                        </a-tag>
                                                        <a-tag color="var(--opacity-buy)" v-else>
                                                            <span class="color-green">{{ $t('futures.short') }}</span>
                                                        </a-tag>
                                                    </div>
                                                    <!--  开仓均价 -->
                                                    <div class="cellItem" style="width: 120px !important;">
                                                        <span class="color-black">
                                                            {{$util.thousandSeparator(item['price'],current?.decimals || 2)}}
                                                        </span>
                                                    </div>
                                                    <!--  平仓均价 -->
                                                    <div class="cellItem" style="width: 120px !important;">
                                                        <span class="color-black">
                                                            {{$util.float(item['t_price_3'] === null ? item['t_price_4']:item['t_price_3'])}}
                                                        </span>
                                                    </div>
                                                    <!--  仓位数量 -->
                                                    <div class="cellItem" style="width: 120px !important;">
                                                        <span class="color-black">{{$util.float(item?.amount || 0)}} {{item?.symbol || 'BTC'}}</span>
                                                    </div>
                                                    <!--  已实盈亏 -->
                                                    <div class="cellItem" style="width: 120px !important;">
                                                        <span :class="{'color-red':item['profit']<=0,'color-green':item['profit']>0}">{{$util.thousandSeparator(item['profit'])}} USDT</span>
                                                    </div>
                                                    <!--  手续费 -->
                                                    <div class="cellItem" style="width: 120px !important;">
                                                        <span class="color-red">{{$util.thousandSeparator(item['charge'])}} USDT</span>
                                                    </div>
                                                    <!--  资金费用 -->
                                                    <div class="cellItem" style="width: 120px !important;">
                                                        <span class="color-black">0.00 USDT</span>
                                                    </div>
                                                    <!--  平仓时间 -->
                                                    <div class="cellItem" style="width: 120px !important;">
                                                        <span class="color-black">{{item['created_at']}}</span>
                                                    </div>
                                                </div>
                                            </a-scrollbar>
                                        </div>
                                        <notlog style="height: calc(100% - 55px)" v-if="false"></notlog>
                                    </a-scrollbar>
                                </a-tab-pane>
                                <a-tab-pane key="6" title="成交记录" v-if="false">
                                    <a-scrollbar style="height:306px;overflow: auto;">
                                        <!--   table    -->
                                        <div class="top_table flex flex-row align-center" type="tab6">
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">合约</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">开仓均价</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">方向</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">成交数量</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">角色</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">手续费</span>
                                            </div>
                                            <div class="tableItem">
                                                <span class="font-12 color-gray">时间</span>
                                            </div>
                                        </div>
                                        <div class="listWarp" type="tab6">
                                            <a-scrollbar outer-class="listWarp">
                                                <!--  列表项 -->
                                                <div class="cell flex flex-row align-center" v-for="(item,index) in (history.profit ? history.profit : [])" :key="'profit'+item.id">
                                                    <!--  合约 -->
                                                    <div class="cellItem">
                                                        <span class="coin color-black">{{item?.symbol || 'BTC'}}USDT</span>
                                                    </div>
                                                    <!--  开仓均价 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">
                                                            {{$util.float(item['price'])}}
                                                        </span>
                                                    </div>
                                                    <!--  方向 -->
                                                    <div class="cellItem">
                                                        <a-tag color="var(--opacity-sell)" v-if="item.direction === 2">
                                                            <span class="color-red">{{ $t('futures.long_direction') }}</span>
                                                        </a-tag>
                                                        <a-tag color="var(--opacity-buy)" v-else>
                                                            <span class="color-green">{{ $t('futures.short_direction') }}</span>
                                                        </a-tag>
                                                    </div>
                                                    <!--  成交数量 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">{{$util.float(item?.amount || 0)}} {{item?.symbol || 'BTC'}}</span>
                                                    </div>
                                                    <!--  角色 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">taker</span>
                                                    </div>
                                                    <!--  手续费 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">0.0725 USDT</span>
                                                    </div>
                                                    <!--  时间 -->
                                                    <div class="cellItem">
                                                        <span class="color-black">2023-11-28 10:28:26</span>
                                                    </div>
                                                </div>
                                            </a-scrollbar>
                                        </div>
                                        <notlog style="height: calc(100% - 55px)" v-if="false"></notlog>
                                    </a-scrollbar>
                                </a-tab-pane>
                            </a-tabs>
                        </div>
                    </div>
                </div>

                <!--     -->
                <div class="content_main_right">
                    <div class="content_main_right_top">
                        <div class="_hd flex align-center jus-bet">
                            <div class="flex align-center">
                                <div class="flex align-center jus-center pointer mr-20" @click="marginModel = true">
                                    <span class="font-14 color-gray mr-5">{{positionModel === 0 ? $t('futures.cross_margin') : $t('futures.isolated_margin')}}</span>
                                    <icon-swap class="color-gray"/>
                                </div>
                                <div class="flex align-center jus-center pointer" @click="leverArm = true">
                                    <span class="font-14 color-gray mr-5">{{leverVal}}X</span>
                                    <icon-swap class="color-gray"/>
                                </div>
                            </div>
                            <img class="pointer" src="@/assets/images/calculator.svg" @click="calculator = true">
                        </div>
                        <div class="_mn">
                            <!-- 开仓/平仓-->
                            <div class="flex align-center jus-bet">
                                <div class="btn" :class="btnActive===0?'buyActive':''" @click="btnActive = 0">{{ $t('futures.open_position') }}</div>
                                <div class="btn" :class="btnActive===1?'sellActive':''" @click="btnActive = 1">{{ $t('futures.close_position') }}</div>
                            </div>
                            <!-- 模式-->
                            <div class="flex align-center jus-start mode_group">
                                <div class="pad-lr-10 pointer mode_item"
                                     :class="modeIndex === index ? 'modeAcitve' : ''" v-for="(item,index) in modeOption"
                                     :key="index"
                                     @click="modeIndex = index">
                                    <span class="font-14 color-black" :class="{'font-bold': modeIndex === index}">{{
                                            index === 0
                                                ? $t('futures.order_types.limit')
                                                : index === 1
                                                    ? $t('futures.order_types.market')
                                                    : $t('futures.order_types.conditional')
                                        }}</span>
                                </div>
                            </div>
                            <!--  -->
                            <div class="_row flex align-center jus-bet" v-if="btnActive===0">
                                <div class="flex align-center">
                                    <span class="font-12 color-gray mr-5">{{ $t('futures.available') }}</span>
                                    <span class="font-14 color-primary">{{$util.thousandSeparator(balance.legal_balance || 0)}} USDT</span>
                                </div>
<!--                                <div class="flex align-center" v-else>-->
<!--                                    <span class="font-12 color-gray mr-5">可平</span>-->
<!--                                    <span class="font-14 color-primary">{{$util.thousandSeparator(balance.legal_balance)}} USDT</span>-->
<!--                                </div>-->
                                <div class="transferIcon" @click="transfeShow = true">
                                    <icon-swap/>
                                </div>
                            </div>
                            <!--  -->
                            <div class="_row _row_box flex align-center jus-bet" v-if="modeIndex == 0">
                                <span class="font-12 color-gray">{{ $t('futures.price') }}</span>
                                <a-input 
                                  id="futures-price"
                                  name="price"
                                  type="text" 
                                  v-model="price" 
                                  :placeholder="$t('futures.transaction_price')"/>
                                <span class="font-12 color-gray">USDT</span>
                            </div>
                            <!--  -->
                            <div class="_row _row_box flex align-center jus-bet" v-if="modeIndex == 2">
                                <a-tooltip background-color="var(--tooltip-bg)">
                                    <span class="font-12 color-gray dotted cursor">{{ $t('futures.trigger_price') }}</span>
                                    <template #content>
                                        <p class="font-12 color-always-white">
                                            {{ $t('futures.trigger_price_tip') }}</p>
                                    </template>
                                </a-tooltip>
                                <a-input type="text" v-model="wprice" placeholder=""/>
                                <span class="font-12 color-gray">USDT</span>
                            </div>
                            <div class="_row flex align-center jus-bet" type="select" v-if="modeIndex == 2">
                                <div class="_subbox flex align-center jus-bet">
                                    <div class="_subbox_left">
                                        <span class="font-12 color-gray">{{ $t('futures.price') }}</span>
                                        <div class="flex align-center jus-end inputBox">
                                            <a-input class="mr-10" :disabled="limitType!==0" v-model="price" type="text" placeholder=""/>
                                            <span class="font-12 color-gray">USDT</span>
                                        </div>
                                    </div>
                                    <a-dropdown :render-to-body="false" :popup-max-height="false">
                                        <div class="selectTag">
                                            <a-tooltip position="lb" background-color="var(--tooltip-bg)">
                                                <span class="color-black font-12 dotted mr-5">{{limitType === 0 ? $t('futures.limit_order') : $t('futures.market_order')}}</span>
                                                <icon-caret-down/>
                                                <template #content>
                                                    <p class="font-12 color-always-white">
                                                        {{ $t('futures.limit_order_tip') }}
                                                    </p>
                                                </template>
                                            </a-tooltip>
                                        </div>
                                        <template #content>
                                            <a-doption @click="limitType=0">{{ $t('futures.limit_order') }}</a-doption>
                                            <a-doption @click="limitType=1">{{ $t('futures.market_order') }}</a-doption>
                                        </template>
                                    </a-dropdown>
                                </div>
                            </div>
                            <!--  -->
                            <div class="_row _row_box flex align-center jus-bet" type="select">
                                <span class="font-12 color-gray">{{ $t('futures.quantity') }}</span>
                                <a-input type="text" v-model="amount" placeholder=""/>
                                <a-dropdown :render-to-body="true" :popup-max-height="false">
                                    <span class="font-12 color-gray flex align-center pointer"><b
                                            class="mr-5 color-black">{{amounType===0?(current?.symbol || 'BTC'):'USDT'}}</b> <icon-caret-down/></span>
                                    <template #content>
                                        <a-doption @click="amounType=0">{{current?.symbol || 'BTC'}}</a-doption>
                                        <a-doption @click="amounType=1">USDT</a-doption>
                                    </template>
                                </a-dropdown>
                            </div>
                            <p class="tipText" v-if="isLogin && balance.legal_balance <= (current?.min_amount || 0)">{{ $t('futures.insufficient_balance') }}</p>
                            <!--            -->
                            <div class="_row">
                                <a-slider @change="sliderChange" v-model="rate" :default-value="rate" :max="100" :marks="marks"/>
                            </div>
                            <!-- 止盈止损已隐藏 -->
                            <!--  -->
                            <div class="_row flex align-center jus-bet" type="select" v-if="false">
                                <div class="flex align-center pointer">
                                    <a-checkbox class="mr-5" value="1"></a-checkbox>
                                    <a-dropdown :render-to-body="false" :popup-max-height="false">
                                        <span class="font-14 color-gray">只做maker <icon-caret-down/></span>
                                        <template #content>
                                            <a-doption>只做Maker</a-doption>
                                            <a-doption>
                                                IOC
                                                <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                                    <icon-question-circle-fill class="color-gray pointer"/>
                                                    <template #content>
                                                        <span
                                                                class="font-12 color-always-white">未成交部分订单立即取消</span>
                                                    </template>
                                                </a-tooltip>
                                            </a-doption>
                                            <a-doption>
                                                FOK
                                                <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                                    <icon-question-circle-fill class="color-gray pointer"/>
                                                    <template #content>
                                                        <span
                                                                class="font-12 color-always-white">订单全部成交或立即取消</span>
                                                    </template>
                                                </a-tooltip>
                                            </a-doption>
                                        </template>
                                    </a-dropdown>
                                </div>
                            </div>
                            <!--            login-->
                            <div class="_row _row_box flex align-center jus-center" v-if="isLogin === false">
                                <span class="font-14 color-primary mr-5 pointer" @click="$router.push('/login')">{{ $t('nav.login') }}</span>
                                <span class="font-14 color-gray mr-5">{{ $t('common.or') }}</span>
                                <span class="font-14 color-primary pointer" @click="$router.push('/register')">{{ $t('nav.register') }}</span>
                            </div>
                            <div class="buttonGroup flex align-center jus-bet" v-else>
                                <template v-if="btnActive === 0">
                                    <a-button class="button" :loading="loading" mode="buy" @click="submitOrder(1)">
                                        {{ $t('futures.open_long') }}
                                    </a-button>
                                    <a-button class="button" :loading="loading" mode="sell" @click="submitOrder(2)">
                                        {{ $t('futures.open_short') }}
                                    </a-button>
                                </template>
                                <template v-else>
                                    <a-button class="button" :loading="loading" mode="buy" @click="closePositionByForm(1)">
                                        {{ $t('futures.close_long') }}
                                    </a-button>
                                    <a-button class="button" :loading="loading" mode="sell" @click="closePositionByForm(2)">
                                        {{ $t('futures.close_short') }}
                                    </a-button>
                                </template>
                            </div>

                            <!--  -->
                            <div class="_row flex align-center jus-bet">
                                <template v-if="btnActive === 0">
                                    <div class="flex align-center">
                                        <span class="font-12 color-gray">{{ $t('futures.can_open_long') }}</span>
                                        <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                            <icon-question-circle-fill class="color-gray pointer mr-5"/>
                                            <template #content>
                                                <span class="font-12 color-always-white">{{ $t('futures.max_buy_amount_tip') }}</span>
                                            </template>
                                        </a-tooltip>
                                        <span class="font-12 color-black">{{getTopAmount(1,current?.new_price || 0)}} {{amounType === 0 ? (current?.symbol || 'BTC'):'USDT'}}</span>
                                    </div>
                                    <div class="flex align-center">
                                        <span class="font-12 color-gray">{{ $t('futures.can_open_short') }}</span>
                                        <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                            <icon-question-circle-fill class="color-gray pointer mr-5"/>
                                            <template #content>
                                                <span class="font-12 color-always-white">{{ $t('futures.max_sell_amount_tip') }}</span>
                                            </template>
                                        </a-tooltip>
                                        <span class="font-12 color-black">{{getTopAmount(2,current?.new_price || 0)}} {{amounType === 0 ? (current?.symbol || 'BTC'):'USDT'}}</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="flex align-center">
                                        <span class="font-12 color-gray">{{ $t('futures.can_close_long') }}</span>
                                        <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                            <icon-question-circle-fill class="color-gray pointer mr-5"/>
                                            <template #content>
                                                <span class="font-12 color-always-white">{{ $t('futures.position_accumulated_amount') }}</span>
                                            </template>
                                        </a-tooltip>
                                        <span class="font-12 color-black">{{$util.thousandSeparator(getPositionAmount(1),8)}} {{current?.symbol || 'BTC'}}</span>
                                    </div>
                                    <div class="flex align-center">
                                        <span class="font-12 color-gray">{{ $t('futures.can_close_short') }}</span>
                                        <a-tooltip position="bottom" background-color="var(--tooltip-bg)">
                                            <icon-question-circle-fill class="color-gray pointer mr-5"/>
                                            <template #content>
                                                <span class="font-12 color-always-white">{{ $t('futures.position_accumulated_amount') }}</span>
                                            </template>
                                        </a-tooltip>
                                        <span class="font-12 color-black">{{$util.thousandSeparator(getPositionAmount(2),8)}} {{current?.symbol || 'BTC'}}</span>
                                    </div>
                                </template>
                            </div>
                            <!--  -->
                            <div class="_row flex align-center jus-bet">
                                <template v-if="btnActive===0">
                                    <div class="flex align-center">
                                        <span class="font-12 color-gray mr-5">{{ $t('futures.margin') }}</span>
                                        <span class="font-12 color-black">{{$util.thousandSeparator(getMarginAmount(current?.new_price || 0),2)}} USDT</span>
                                    </div>
                                    <div class="flex align-center">
                                        <span class="font-12 color-gray mr-5">{{ $t('futures.margin') }}</span>
                                        <span class="font-12 color-black">{{$util.thousandSeparator(getMarginAmount(current?.new_price || 0),2)}} USDT</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="flex align-center">
                                        <span class="font-12 color-gray mr-5">{{ $t('futures.estimated_pnl') }}</span>
                                        <span class="font-12 color-black">{{$util.thousandSeparator(getStopProfit(amount)['long'],2)}} USDT</span>
                                    </div>
                                    <div class="flex align-center">
                                        <span class="font-12 color-gray mr-5">{{ $t('futures.estimated_pnl') }}</span>
                                        <span class="font-12 color-black">{{$util.thousandSeparator(getStopProfit(amount)['short'],2)}} USDT</span>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="content_main_right_bottom">
                        <div class="_hd _bottom_tb flex align-center jus-bet">
                            <span class="font-14 color-black">{{ $t('futures.contract_info') }}</span>
                            <span class="font-12 color-primary pointer" >{{ $t('futures.contract_data') }}</span>
<!--                            @click="toDetail"-->
                        </div>
                        <div class="btm_cl flex align-center jus-bet">
                            <span class="font-12 color-gray">{{ $t('futures.contract_symbol') }}</span>
                                                            <span class="font-14 color-black">{{current?.symbol || 'BTC'}}USDT</span>
                        </div>
                        <div class="btm_cl flex align-center jus-bet">
                            <span class="font-12 color-gray">{{ $t('futures.delivery_date') }}</span>
                            <span class="font-14 color-black">{{ $t('futures.perpetual') }}</span>
                        </div>
                        <div class="btm_cl flex align-center jus-bet">
                            <span class="font-12 color-gray">{{ $t('futures.contract_underlying') }}</span>
                                                            <span class="font-14 color-black">{{current?.symbol || 'BTC'}}USDT {{ $t('futures.index') }}</span>
                        </div>
                        <div class="btm_cl flex align-center jus-bet">
                            <span class="font-12 color-gray">{{ $t('futures.margin_currency') }}</span>
                            <span class="font-14 color-black">USDT</span>
                        </div>
                        <div class="btm_cl flex align-center jus-bet">
                            <span class="font-12 color-gray">{{ $t('futures.contract_face_value') }}</span>
                                                            <span class="font-14 color-black">{{$util.float(current?.face_value || 0)}} {{current?.symbol || 'BTC'}}</span>
                        </div>
                        <div class="btm_cl flex align-center jus-bet">
                            <span class="font-12 color-gray">{{ $t('futures.min_price_change_unit') }}</span>
                            <span class="font-14 color-black">0.01 USDT</span>
                        </div>
                        <div class="btm_cl flex align-center jus-bet">
                            <span class="font-12 color-gray">{{ $t('futures.min_maintenance_margin_rate') }}</span>
                            <span class="font-14 color-black">1.00 %</span>
                        </div>
                        <div class="btm_cl flex align-center jus-bet">
                            <span class="font-12 color-gray">{{ $t('futures.settlement_cycle') }}</span>
                            <span class="font-14 color-black">{{ $t('futures.real_time') }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </a-layout-content>
        <a-layout-footer class="layoutFooter">
        </a-layout-footer>

        <!--      币种介绍-->
        <a-modal :closable="false"
                 align-center
                 width="960px"
                 modalClass="modal_main dark"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 :hide-title="true"
                 :footer="false"
                 :visible="aboutCoin">
            <div class="modal_main flex flex-row align-center jus-bet">
                <!--          close-->
                <div class="close" @click="aboutCoin=false">
                    <icon-close class="color-black pointer" size="24"/>
                </div>
                <!--          -->
                <div class="modal_main_left flex flex-column">
                    <p class="font-20 font-bold color-black">{{ $t('futures.currency_introduction') }}</p>
                    <p class="flex align-center font-20 font-bold color-black">
                        <img class="mr-5" :src="current?.icon || ''">
                                                    {{ current?.symbol || 'BTC' }}/USDT
                    </p>
                    <!--            排名-->
                    <p class="font-14 color-gray flex align-center jus-bet">{{ $t('futures.ranking') }}
                        <span class="color-black">No.{{currencyInfo['marketSort']}}</span>
                    </p>
                    <!--            市值-->
                    <p class="font-14 color-gray flex align-center jus-bet">{{ $t('futures.market_cap') }}
                        <span class="color-black">{{currencyInfo['marketValue']}}</span>
                    </p>
                    <!--            市场占有率-->
                    <p type="line" class="font-14 color-gray flex align-center jus-bet">{{ $t('futures.market_share') }}
                        <span class="color-black">{{currencyInfo['marketShare']}}</span>
                    </p>
                    <!--            流通量-->
                    <p class="font-14 color-gray flex align-center jus-bet">{{ $t('futures.circulation') }}
                                                        <span class="color-black">{{currencyInfo['Circulation']}} {{ current?.symbol || 'BTC' }}</span>
                    </p>
                    <!--            最大供应量-->
                    <p class="font-14 color-gray flex align-center jus-bet">{{ $t('futures.max_supply') }}
                                                        <span class="color-black">{{currencyInfo['totalCurrency']}} {{ current?.symbol || 'BTC' }}</span>
                    </p>
                    <!--            流通率-->
                    <p class="font-14 color-gray flex align-center jus-bet">{{ $t('futures.circulation_rate') }}
                                                        <span class="color-black">{{currencyInfo['CirculationRate']}} {{ current?.symbol || 'BTC' }}</span>
                    </p>
                    <!--            发行日期-->
                    <p class="font-14 color-gray flex align-center jus-bet">{{ $t('futures.issue_date') }}
                        <span class="color-black">{{currencyInfo['issueDate']}}</span>
                    </p>
                    <!--            发行价格-->
                    <p type="line" class="font-14 color-gray flex align-center jus-bet">{{ $t('futures.issue_price') }}
                        <span class="color-black">{{currencyInfo['IssuePrice']}}</span>
                    </p>
                    <!--            历史最高价-->
                    <p class="font-14 color-gray flex align-center jus-bet">{{ $t('futures.historical_high') }}
                        <span class="color-black">{{currencyInfo['hightPrice']}}</span>
                    </p>
                    <!--            历史最低价-->
                    <p class="font-14 color-gray flex align-center jus-bet">{{ $t('futures.historical_low') }}
                        <span class="color-black">{{currencyInfo['IssuePrice']}}</span>
                    </p>
                </div>
                <div class="modal_main_right flex flex-column">
                                            <p class="font-20 font-bold color-black">关于{{ current?.symbol || 'BTC' }}</p>
                    <p class="font-14 color-black">
                        {{ current?.symbol || 'BTC' }} -
                        简介详情
                    </p>
                    <a-scrollbar type="embed" class="scroll">
                        {{currencyInfo['about']}}
                    </a-scrollbar>
                    <p class="font-20 font-bold color-black">官方链接</p>
                    <div class="flex align-center">
                        <a href="" class="font-14 color-primary pad-lr-10">官网</a>
                        <a href="" class="font-14 color-primary pad-lr-10">Github</a>
                        <a href="" class="font-14 color-primary pad-lr-10">区块浏览器</a>
                        <a href="/DBG_Whitepaper.pdf" target="_blank" class="font-14 color-primary pad-lr-10">白皮书</a>
                    </div>
                    <p class="font-20 font-bold color-black">社交媒体</p>
                    <div class="flex align-center">
                        <img class="img-small mr-12 pointer" src="@/assets/images/instagram.png">
                        <img class="img-small mr-12 pointer" src="@/assets/images/tw.png">
                        <img class="img-small mr-12 pointer" src="@/assets/images/facebook.png">
                    </div>
                </div>
            </div>
        </a-modal>
        <!--      保证金模式 -->
        <a-modal :visible="marginModel"
                 align-center
                 :render-to-body="false"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 modal-class="popupWarp"
                 width="360px"
                 :hide-title="true"
                 :mask-closable="true"
                 :footer="false">
            <div class="popupBox">
                <div class="popupBox-title">
                                                    <span class="title">{{current?.symbol || 'BTC'}}USDT{{ $t('futures.margin_mode') }}</span>
                    <icon-close @click="marginModel = false" size="24"/>
                </div>
                <div class="popupBox-content">
                    <a-radio-group type="radio" @change="positionChange" size="large" class="radioGroup">
                        <a-radio class="radioLabel" :model-value="all" :value="0">
                            <span class="color-black">{{ $t('futures.cross_margin') }}</span>
                        </a-radio>
                        <a-radio class="radioLabel" :model-value="signal" :value="1">
                            <span class="color-black">{{ $t('futures.isolated_margin') }}</span>
                        </a-radio>
                    </a-radio-group>
                    <p class="desc color-gray">{{ $t('futures.cross_margin_desc') }}</p>
                    <div class="buttonGroup">
                        <a-button class="button" @click="marginModel = false">
                            <span>{{ $t('common.cancel') }}</span>
                        </a-button>
                        <a-button class="button" @click="confirmPositionChange">
                            <span>{{ $t('common.confirm') }}</span>
                        </a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <!--      杠杆 -->
        <a-modal :visible="leverArm"
                 align-center
                 :render-to-body="false"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 modal-class="popupWarp"
                 width="370px"
                 :hide-title="true"
                 :mask-closable="true"
                 :footer="false">
            <div class="popupBox">
                <div class="popupBox-title">
                                                    <span class="title">{{current?.symbol || 'BTC'}}USDT {{ $t('futures.contract_leverage') }}</span>
                    <icon-close @click="leverArm = false" size="24"/>
                </div>
                <div class="popupBox-content">
                    <div class="inputBox">
                        <span>{{ $t('futures.leverage_multiplier') }}</span>
                        <a-input-number mode="embed" v-model="leverVal" :max="current?.max_lever || 125" :min="current?.min_lever || 1" :hide-button="false"
                                        placeholder="1"
                                        class="leverInput">
                            <template #plus>
                                <icon-plus/>
                            </template>
                            <template #minus>
                                <icon-minus/>
                            </template>
                        </a-input-number>
                    </div>
                    <div class="sliderBox">
                        <a-slider class="slider" v-model="leverVal" :default-value="1" :min="1" :max="125"
                                  :marks="leverSlider"/>
                        <p v-if="leverVal == 1">{{ $t('futures.max_leverage_support', {max: current?.max_lever || 125}) }}</p>
                    </div>
                    <ul class="tips">
                        <li class="tipsItem">
                            <span>{{ $t('futures.max_position_at_leverage', {amount: $util.thousandSeparator(current?.max_amount || 0,current?.decimals || 2), symbol: current?.symbol || 'BTC'}) }}</span>
                        </li>
                        <li class="tipsItem">
                            <span>{{ $t('futures.leverage_change_notice') }}</span>
                        </li>
                        <li class="tipsItem">
                            <span>{{ $t('futures.high_leverage_risk') }}</span>
                        </li>
                    </ul>
                    <div class="buttonGroup">
                        <a-button class="button" @click="leverArm = false">
                            <span>{{ $t('common.cancel') }}</span>
                        </a-button>
                        <a-button class="button" @click="setPositionLever">
                            <span>{{ $t('common.confirm') }}</span>
                        </a-button>
                    </div>
                </div>
            </div>
        </a-modal>
        <!--      计算器 -->
        <a-modal :visible="calculator"
                 align-center
                 :render-to-body="false"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 modal-class="popupWarp"
                 width="672px"
                 :hide-title="true"
                 :mask-closable="true"
                 :footer="false">
            <view class="popupBox">
                <div class="popupBox-title">
                    <span class="title">{{ $t('futures.calculator') }}</span>
                    <icon-close @click="calculator = false" size="24"/>
                </div>
                <div class="popupBox-content">
                    <div class="tabControl">
                        <div class="tabItem"
                             v-for="(tItem,index) in tabOption" :key="index"
                             :class="tabIndex === index ? 'tabItem-active' : ''"
                             @click="tabIndex = index">
                            <span class="color-always-white">{{ tItem }}</span>
                        </div>
                    </div>
                    <div class="tabContent">
                        <div class="tabContent-item">
                            <div class="shapedButton">
                                <div class="button" :class="buying === 1 ? 'buyActive' : ''" @click="buying = 1">
                                    <span class="color-always-white">{{ $t('futures.buy_long') }}</span>
                                </div>
                                <div class="button" :class="buying === 2 ? 'sellActive' : ''" @click="buying = 2">
                                    <span class="color-always-white">{{ $t('futures.sell_long') }}</span>
                                </div>
                            </div>
                            <div class="inputBox">
                                <span>{{ $t('futures.leverage_multiplier') }}</span>
                                <a-input-number mode="embed"
                                                v-model="cleverVal"
                                                :max="current?.max_lever || 125"
                                                :min="1"
                                                :hide-button="false"
                                                placeholder="0"
                                                class="leverInput">
                                    <template #plus>
                                        <icon-plus/>
                                    </template>
                                    <template #minus>
                                        <icon-minus/>
                                    </template>
                                </a-input-number>
                            </div>
                            <div class="sliderBox">
                                <a-slider class="slider" v-model="cleverVal" :default-value="1" :min="1" :max="current?.max_lever || 125"
                                          :marks="leverSlider"/>
                                <p> <span class="color-orange">{{ $t('futures.max_position_at_current_leverage', {amount: $util.float(current?.max_amount || 0), symbol: current?.symbol || 'BTC'}) }}</span></p>
                            </div>
                            <div class="inputBox">
                                <span>{{ $t('futures.open_price') }}</span>
                                <a-input class="input" v-model="cprice" placeholder="">
                                    <template #append>
                                        USDT
                                    </template>
                                </a-input>
                            </div>
                            <div v-if="tabIndex === 0">
                                <div class="inputBox">
                                    <span>{{ $t('futures.close_price') }}</span>
                                    <a-input class="input" v-model="cwprice" placeholder="">
                                        <template #append>
                                            USDT
                                        </template>
                                    </a-input>
                                </div>
                                <div class="inputBox">
                                    <span>{{ $t('futures.quantity') }}</span>
                                    <a-input class="input" v-model="camount" placeholder="">
                                        <template #append>
                                            {{current?.symbol || 'BTC'}}
                                        </template>
                                    </a-input>
                                </div>
                            </div>

                            <div v-if="tabIndex === 1">
                                <div class="inputBox">
                                    <span>{{ $t('futures.return_rate') }}</span>
                                    <a-input class="input" placeholder="">
                                        <template #append>
                                            %
                                        </template>
                                    </a-input>
                                </div>
                            </div>
                            <div v-if="tabIndex === 2">
                                <div class="inputBox">
                                    <span>{{ $t('futures.position_amount') }}</span>
                                    <a-input class="input" placeholder="">
                                        <template #append>
                                            BTC
                                        </template>
                                    </a-input>
                                </div>
                                <div class="inputBox">
                                    <span>{{ $t('futures.margin_amount') }}</span>
                                    <a-input class="input" placeholder="">
                                        <template #append>
                                            USDT
                                        </template>
                                    </a-input>
                                </div>
                            </div>
                            <div class="buttonGroup">
                                <a-button class="button" @click="leverArm = false">
                                    <span>{{ $t('futures.calculate') }}</span>
                                </a-button>
                            </div>
                        </div>
                        <div class="tabContent-item">
                            <div class="rowCell title">
                                <span>{{ $t('futures.calculation_result') }}</span>
                            </div>
                            <div v-if="tabIndex === 0">
                                <div class="rowCell">
                                    <span>{{ $t('futures.open_margin') }}</span>
                                    <span>{{camount !== '' && cprice  !== '' && cwprice  !== '' ? $util.thousandSeparator((current?.new_price || 0) * camount / cleverVal):'--'}} USDT</span>
                                </div>
                                <div class="rowCell">
                                    <span>{{ $t('futures.estimated_profit') }}</span>
                                    <span>
                                        {{camount !== '' && cprice  !== '' && cwprice  !== '' ? $util.thousandSeparator((buying === 1 ? cwprice - cprice : cprice - cwprice) * camount) : '--'}}
                                    </span>
                                </div>
                                <div class="rowCell">
                                    <span>{{ $t('futures.profit_rate') }}</span>
                                    <span>
                                        {{camount !== '' && cprice  !== '' && cwprice  !== '' ? $util.thousandSeparator(((buying === 1 ? cwprice - cprice : cprice - cwprice) * camount) / ((current?.new_price || 0) * camount / cleverVal) * 100,2):'--' }}%
                                    </span>
                                </div>
                            </div>
                            <div class="rowCell" v-if="tabIndex === 1">
                                <span>{{ $t('futures.close_price') }}</span>
                                <span>
                                    {{camount !== '' && cprice  !== '' && cwprice  !== '' ? $util.thousandSeparator((buying === 1 ? cprice + ((current?.new_price || 0) * camount / cleverVal) / camount : cprice - ((current?.new_price || 0) * camount / cleverVal) / camount)):'--'}} USDT
                                </span>
                            </div>
                            <div class="rowCell" v-if="tabIndex === 2">
                                <span>{{ $t('futures.liquidation_price') }}</span>
                                <span>
                                    {{camount !== '' && cprice  !== '' && cwprice  !== '' ? $util.thousandSeparator((buying === 1 ? parseFloat(cprice) + parseFloat(((current?.new_price || 0) * camount / cleverVal) / camount) : parseFloat(cprice) - ((current?.new_price || 0) * camount / cleverVal) / camount)):'--'}} USDT
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </view>
        </a-modal>
        <!--    资金划转-->
        <funds-transfe :visible="transfeShow" @close="transfeShow=false" @success="getBalance"></funds-transfe>
        <!--    下单-->
        <a-modal :visible="placeOrder"
                 align-center
                 :render-to-body="false"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 modal-class="popupWarp"
                 width="400px"
                 :hide-title="true"
                 :mask-closable="true"
                 :footer="false">
            <div class="popupBox-title">
                <span class="title" v-if="modeIndex===1">{{ $t('futures.market_order_type') }}</span>
                <span class="title" v-if="modeIndex===0">{{ $t('futures.limit_order_type') }}</span>
                <span class="title" v-if="modeIndex===2">{{ $t('futures.conditional_order_type') }}</span>
                <icon-close @click="placeOrder = false" size="20"/>
            </div>
            <div class="popupBox-content">
                <div class="itemCell">
                    <a-tag color="var(--opacity-sell)">
                        <span class="color-red">{{submitDirection === 1 ? $t('futures.long_direction'):$t('futures.short_direction')}}</span>
                    </a-tag>
                    <span class="title color-black">{{current?.symbol || 'BTC'}}USDT</span>
                    <a-tag color="var(--opacity-gray)">
                                                                            <span class="color-black">{{positionModel === 0 ? $t('futures.position_cross_margin'):$t('futures.position_isolated_margin')}}{{leverVal}}X</span>
                    </a-tag>
                </div>
                <div class="itemCell">
                    <span class="color-gray">{{$util.getDateTimeStr()}}</span>
                </div>
                <div class="itemCell">
                    <span class="color-gray">{{ $t('futures.price') }}</span>
                                                        <span class="color-black">{{price === '' ? $t('futures.market_price'):$util.thousandSeparator(price,current?.decimals || 2)}}</span>
                </div>
                <div class="itemCell">
                    <span class="color-gray">{{ $t('futures.quantity') }}</span>
                                                    <span class="color-black">{{$util.thousandSeparator(amount)}} {{amounType === 0 ? (current?.symbol || 'BTC'):'USDT'}}</span>
                </div>
                <div class="itemCell">
                    <span class="color-gray">{{ $t('futures.margin') }}</span>
                    <span class="color-black">{{getMarginAmount(current?.new_price || 0)}} USDT</span>
                </div>
                <div class="itemCell">
                    <a-checkbox v-model="checked">
                        <span class="color-gray">{{ $t('futures.dont_show_again_tip') }}</span>
                    </a-checkbox>
                </div>
                <div class="buttonGroup">
                    <a-button class="button" @click="placeOrder = false;loading=false">
                        <span>{{ $t('common.cancel') }}</span>
                    </a-button>
                    <a-button class="button" @click="submitOrder(submitDirection,false)">
                        <span>{{ $t('common.confirm') }}</span>
                    </a-button>
                </div>
            </div>
        </a-modal>
        <!--    平仓-->
        <a-modal :visible="closePotion"
                 align-center
                 :render-to-body="false"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 modal-class="popupWarp"
                 width="400px"
                 :hide-title="true"
                 :mask-closable="true"
                 :footer="false">
            <div class="popupBox-title">
                <span class="title">{{ $t('futures.close_position') }}</span>
                <icon-close @click="closePotion = false" size="20"/>
            </div>
            <div class="popupBox-content" v-if="pindex !== false">
                <div class="itemCell">
                    <a-tag color="var(--opacity-sell)">
                        <span class="color-red" v-if="parseInt(position?.position?.[pindex]?.direction || 0) === 2">{{ $t('futures.short') }}</span>
                        <span class="color-green" v-if="parseInt(position?.position?.[pindex]?.direction || 0) === 1">{{ $t('futures.long') }}</span>
                    </a-tag>
                    <span class="title color-black">{{position?.position?.[pindex]?.symbol || 'BTC'}}USDT</span>
                    <a-tag color="var(--opacity-gray)">
                        <span class="color-black">
                            {{position?.position?.[pindex]?.margin_type === 1 ? $t('futures.cross_margin') : $t('futures.isolated_margin')}}{{position?.position?.[pindex]?.muilt || 0}}X
                        </span>
                    </a-tag>
                </div>
                <div class="tabControl closePotionTabs">
                    <div class="tabItem"
                         v-for="(tItem,index) in closePotionTab" :key="index"
                         :class="tabIndex === index ? 'tabItem-active' : ''"
                         @click="tabIndex = index">
                        <span class="color-black">{{ tItem }}</span>
                    </div>
                </div>
                <div class="inputBox">
                    <span>{{ $t('futures.position_close_price') }}</span>
                    <a-input class="input" :disabled="tabIndex === 1" v-model="pprice" placeholder="">
                        <template #append>
                            USDT
                        </template>
                    </a-input>
                </div>
                <div class="inputBox">
                    <span>{{ $t('futures.close_amount') }}</span>
                    <a-input class="input" v-model="pamount" placeholder="">
                        <template #append>
                            {{current?.symbol || 'BTC'}}
                        </template>
                    </a-input>
                </div>
                <div class="sliderBox">
                    <a-slider class="slider" @change="psliderChange" :default-value="0" :min="0" :max="100"
                              :marks="marks"/>
                </div>
                <div class="itemCell">
                    <span class="color-gray">{{ $t('futures.closeable_position') }}</span>
                    <span class="color-black">
                                                        {{$util.thousandSeparator((position?.position?.[pindex]?.amount || 0) - (position?.position?.[pindex]?.close || 0),8)}} {{current?.symbol || 'BTC'}}
                    </span>
                </div>
                <div class="itemCell">
                    <span class="color-gray">{{ $t('futures.estimated_profit_loss') }}</span>
                    <span class="color-red">{{getPositionPamount(current?.new_price || 0)}} <span class="color-black">USDT</span></span>
                </div>
                <div class="buttonGroup">
                    <a-button class="button" @click="closePotion = false">
                        <span>{{ $t('common.cancel') }}</span>
                    </a-button>
                    <a-button class="button" :loading="loading" @click="closePositions">
                        <span>{{ $t('common.confirm_action') }}</span>
                    </a-button>
                </div>
            </div>
        </a-modal>
        <!--    闪电平仓-->
        <a-modal :visible="flashClose"
                 align-center
                 :render-to-body="false"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 modal-class="popupWarp"
                 width="400px"
                 :hide-title="true"
                 :mask-closable="true"
                 :footer="false">
            <div class="popupBox-title">
                <span class="title">{{ $t('futures.flash_close_position') }}</span>
                <icon-close @click="flashClose = false" size="20"/>
            </div>
            <div class="popupBox-content" v-if="pindex !== false">
                <div class="itemCell">
                    <a-tag color="var(--opacity-sell)">
                        <span class="color-red" v-if="parseInt(position?.position?.[pindex]?.direction || 0) === 2">{{ $t('futures.short') }}</span>
                        <span class="color-green" v-if="parseInt(position?.position?.[pindex]?.direction || 0) === 1">{{ $t('futures.long') }}</span>
                    </a-tag>
                    <span class="title color-black">{{position?.position?.[pindex]?.symbol || 'BTC'}}USDT</span>
                    <a-tag color="var(--opacity-gray)">
                        <span class="color-black">
                            {{position?.position?.[pindex]?.margin_type === 1 ? $t('futures.cross_margin') : $t('futures.isolated_margin')}}{{position?.position?.[pindex]?.muilt || 0}}X
                        </span>
                    </a-tag>
                </div>
                <div class="itemCell">
                    <span class="color-gray">{{ $t('common.price') }}</span>
                    <span class="color-black">{{ $t('futures.optimal_market_price') }}</span>
                </div>
                <div class="itemCell">
                    <span class="color-gray">{{ $t('common.amount') }}</span>
                    <span class="color-black">{{ $t('futures.all_positions') }}
                                                        <span class="color-primary">{{$util.thousandSeparator((position?.position?.[pindex]?.amount || 0) - (position?.position?.[pindex]?.close || 0),8)}}</span> {{current?.symbol || 'BTC'}}</span>
                </div>
                <div class="buttonGroup">
                    <a-button class="button" @click="flashClose = false">
                        <span>{{ $t('common.cancel') }}</span>
                    </a-button>
                    <a-button class="button" :loading="loading" @click="lightClose">
                        <span>{{ $t('common.confirm') }}</span>
                    </a-button>
                </div>
            </div>
        </a-modal>
        <!--    止盈止损-->
        <a-modal :visible="profitLossPop"
                 align-center
                 :render-to-body="false"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 modal-class="popupWarp"
                 width="840px"
                 :hide-title="true"
                 :mask-closable="true"
                 :footer="false">
            <div class="popupBox-title">
                <span class="title">{{ $t('futures.take_profit_stop_loss') }}</span>
                <icon-close @click="profitLossPop = false" size="24"/>
            </div>
            <div class="popupBox-content" v-if="pindex !== false">
                <div class="itemCell">
                    <a-tag color="var(--opacity-sell)">
                        <span class="color-red" v-if="parseInt(position?.position?.[pindex]?.direction || 0) === 2">{{ $t('futures.short') }}</span>
                        <span class="color-green" v-if="parseInt(position?.position?.[pindex]?.direction || 0) === 1">{{ $t('futures.long') }}</span>
                    </a-tag>
                    <span class="title color-black">{{position?.position?.[pindex]?.symbol || 'BTC'}}USDT</span>
                    <a-tag color="var(--opacity-gray)">
                        <span class="color-black">
                            {{position?.position?.[pindex]?.margin_type === 1 ? $t('futures.cross_margin') : $t('futures.isolated_margin')}}{{position?.position?.[pindex]?.muilt || 0}}X
                        </span>
                    </a-tag>
                </div>
                <div class="columnPirce">
                    <div class="itemCol">
                        <span class="color-gray">{{ $t('futures.position_average_price') }}</span>
                        <span class="color-black">{{$util.thousandSeparator(position?.position?.[pindex]?.price || 0,2)}}</span>
                    </div>
                    <div class="itemCol">
                        <span class="color-gray">{{ $t('futures.latest_price') }}</span>
                        <span class="color-red">{{$util.thousandSeparator(current?.new_price || 0,2)}}</span>
                    </div>
                    <div class="itemCol">
                        <span class="color-gray">{{ $t('futures.estimated_liquidation_price') }}</span>
                        <span class="color-black">{{$util.thousandSeparator(position?.position?.[pindex]?.stopPrice || 0,2)}}</span>
                    </div>
                </div>
                <div class="profit_loss">
                    <div class="item">
                        <div class="inputBox">
                            <div class="inputLeft">
                                <span class="color-green mr-5">{{ $t('futures.take_profit') }}</span>
                                <span class="mr-5 dotted">{{ $t('futures.trigger_price') }}</span>
                                <a-tooltip type="subtip" position="top" background-color="var(--tooltip-bg)">
                                    <icon-question-circle-fill size="16" class="color-gray"/>
                                    <template #content>
                                        <p class="font-12 color-always-white">
                                            {{ $t('futures.trigger_condition') }}
                                        </p>
                                    </template>
                                </a-tooltip>
                            </div>
                            <a-input class="input" v-model="wpwprice" placeholder="">
                                <template #append>
                                    USDT
                                </template>
                            </a-input>
                        </div>
                        <div class="inputGroup">
                            <div class="inputBox">
                                <div class="inputLeft">
                                    <span class="mr-5 dotted">{{ $t('futures.order_price') }}</span>
                                    <a-tooltip type="subtip" position="top" background-color="var(--tooltip-bg)">
                                        <icon-question-circle-fill size="16" class="color-gray"/>
                                        <template #content>
                                            <p class="font-12 color-always-white">
                                                {{ $t('futures.trigger_take_profit_close_position') }}
                                            </p>
                                        </template>
                                    </a-tooltip>
                                </div>
                                <a-input class="input" v-model="wpprice" :disabled="wptype===0" :placeholder="wptype === 0 ? $t('futures.optimal_market_price') : ''">
                                    <template #append>
                                        USDT
                                    </template>
                                </a-input>
                            </div>
                            <a-dropdown type="modeList" :popup-max-height="false">
                                <div class="selectBox">
                                    <span class="color-black">{{wptype === 0 ? $t('futures.market_price') : $t('futures.limit_price')}}</span>
                                    <icon-caret-down size="14" class="color-black"/>
                                </div>
                                <template #content>
                                                                    <a-doption @click="wptype=0">{{ $t('futures.market_price') }}</a-doption>
                                <a-doption @click="wptype=1">{{ $t('futures.limit_price') }}</a-doption>
                                </template>
                            </a-dropdown>
                        </div>
                        <div class="inputBox">
                            <div class="inputLeft">
                                <span class="mr-5">{{ $t('futures.quantity') }}</span>
                            </div>
                            <a-input class="input" v-model="wamount" placeholder="">
                                <template #append>
                                    {{current?.symbol || 'BTC'}}
                                </template>
                            </a-input>
                        </div>
                        <span class="color-gray tipText">
                            {{ $t('futures.position_amount_closeable_amount') }} <span
                                class="color-orange">{{position?.position?.[pindex]?.amount || 0}} / {{$util.thousandSeparator((position?.position?.[pindex]?.amount || 0) - (position?.position?.[pindex]?.close || 0),8)}} {{current?.symbol || 'BTC'}}
                        </span>
                        </span>
                        <div class="sliderBox mt-5">
                            <a-slider class="slider" @change="lsliderChange" :default-value="0" :min="0" :max="100"
                                      :marks="marks"/>
                        </div>
                        <div class="buttonBox">
                            <a-button class="button" @click="profitLossPop = false">
                                <span>{{ $t('common.cancel') }}</span>
                            </a-button>
                        </div>
                    </div>
                    <div class="item">
                        <div class="inputBox">
                            <div class="inputLeft">
                                <span class="color-red mr-5">{{ $t('futures.stop_loss') }}</span>
                                <span class="mr-5 dotted">{{ $t('futures.trigger_price') }}</span>
                                <a-tooltip type="subtip" position="top" background-color="var(--tooltip-bg)">
                                    <icon-question-circle-fill size="16" class="color-gray"/>
                                    <template #content>
                                        <p class="font-12 color-always-white">
                                            {{ $t('futures.trigger_condition') }}
                                        </p>
                                    </template>
                                </a-tooltip>
                            </div>
                            <a-input class="input" v-model="lwprice" placeholder="">
                                <template #append>
                                    USDT
                                </template>
                            </a-input>
                        </div>
                        <div class="inputGroup">
                            <div class="inputBox">
                                <div class="inputLeft">
                                    <span class="mr-5 dotted">{{ $t('futures.order_price') }}</span>
                                    <a-tooltip type="subtip" position="top" background-color="var(--tooltip-bg)">
                                        <icon-question-circle-fill size="16" class="color-gray"/>
                                        <template #content>
                                            <p class="font-12 color-always-white">
                                                {{ $t('futures.trigger_take_profit_close_position') }}
                                            </p>
                                        </template>
                                    </a-tooltip>
                                </div>
                                <a-input class="input" v-model="lprice" :disabled="lptype===0" :placeholder="lptype===0 ? $t('futures.optimal_market_price') : ''">
                                    <template #append>
                                        USDT
                                    </template>
                                </a-input>
                            </div>
                            <a-dropdown type="modeList" :popup-max-height="false">
                                <div class="selectBox">
                                    <span class="color-black">{{lptype===0 ? $t('futures.market_price') : $t('futures.limit_price')}}</span>
                                    <icon-caret-down size="14" class="color-black"/>
                                </div>
                                <template #content>
                                                                    <a-doption @click="lptype=0">{{ $t('futures.market_price') }}</a-doption>
                                <a-doption @click="lptype=1">{{ $t('futures.limit_price') }}</a-doption>
                                </template>
                            </a-dropdown>
                        </div>
                        <div class="inputBox">
                            <div class="inputLeft">
                                <span class="mr-5">{{ $t('futures.quantity') }}</span>
                            </div>
                            <a-input class="input" v-model="lamount" placeholder="">
                                <template #append>
                                    {{current?.symbol || 'BTC'}}
                                </template>
                            </a-input>
                        </div>
                        <span class="color-gray tipText">
                            {{ $t('futures.position_amount_closeable_amount') }} <span
                                class="color-orange">{{position?.position?.[pindex]?.amount || 0}} / {{$util.thousandSeparator((position?.position?.[pindex]?.amount || 0) - (position?.position?.[pindex]?.close || 0),8)}} {{current?.symbol || 'BTC'}}
                        </span>
                        </span>
                        <div class="sliderBox mt-5">
                            <a-slider class="slider" @change="llstopChange" :default-value="0" :min="0" :max="100"
                                      :marks="marks"/>
                        </div>
                        <div class="buttonBox">
                            <a-button class="button" :loading="loading" @click="wlProfitSet">
                                <span>{{ $t('common.confirm') }}</span>
                            </a-button>
                        </div>
                    </div>
                </div>
            </div>
        </a-modal>
        <!--    撤单-->
        <a-modal :visible="wdOrder"
                 align-center
                 :render-to-body="false"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 modal-class="popupWarp"
                 width="400px"
                 :hide-title="true"
                 :mask-closable="true"
                 :footer="false">
            <div class="popupBox-content">
                <div class="imageBox">
                    <img src="@/assets/images/wd_order_img.png" alt="">
                </div>
                <span class="wdContext">{{ $t('futures.confirm_cancel_order') }}</span>
                <div class="buttonGroup">
                    <a-button class="button" @click="wdOrder = false">
                        <span>{{ $t('common.cancel') }}</span>
                    </a-button>
                    <a-button class="button" :loading="loading" @click="cancelOrder">
                        <span>{{ $t('common.confirm') }}</span>
                    </a-button>
                </div>
            </div>
        </a-modal>
        <!--    订单详情-->
        <a-modal :visible="orderInfoPopup"
                 align-center
                 :render-to-body="false"
                 :mask-style="{'background':'rgba(0, 0, 0, .5)'}"
                 modal-class="popupWarp"
                 width="488px"
                 :hide-title="true"
                 :mask-closable="true"
                 :footer="false">
            <div class="popupBox-title">
                <span class="title">{{ $t('futures.order_details') }}</span>
                <icon-close @click="orderInfoPopup = false" size="20"/>
            </div>
            <div class="popupBox-content" v-if="tabPanelIndex===4 && pindex !== false">
                <div class="itemCell oderItemCell">
                    <div class="itemCell_Left">
                        <a-tag color="var(--opacity-sell)">
                            <span class="color-red" v-if="history?.history?.list?.[pindex]?.type === 1">{{ $t('futures.open_long') }}</span>
                            <span class="color-red" v-if="history?.history?.list?.[pindex]?.type === 2">{{ $t('futures.open_short') }}</span>
                            <span class="color-red" v-if="history?.history?.list?.[pindex]?.type === 3">{{ $t('futures.close_long') }}</span>
                            <span class="color-red" v-if="history?.history?.list?.[pindex]?.type === 4">{{ $t('futures.close_short') }}</span>
                            <span class="color-red" v-if="history?.history?.list?.[pindex]?.type === 5">{{ $t('futures.take_profit') }}</span>
                            <span class="color-red" v-if="history?.history?.list?.[pindex]?.type === 6">{{ $t('futures.stop_loss') }}</span>
                        </a-tag>
                        <span class="title color-black">{{history?.history?.list?.[pindex]?.symbol || 'BTC'}}USDT</span>
                        <a-tag color="var(--opacity-gray)">
                            <span class="color-black">{{ $t('futures.perpetual') }}</span>
                        </a-tag>
                    </div>
                    <span class="statusText color-black" v-if="history?.history?.list?.[pindex]?.status===2">{{ $t('futures.completely_filled') }}</span>
                    <span class="statusText color-black" v-if="history?.history?.list?.[pindex]?.status===1">{{ $t('futures.pending') }}</span>
                    <span class="statusText color-black" v-if="history?.history?.list?.[pindex]?.status===3">{{ $t('futures.cancelled') }}</span>
                </div>
                <div class="itemCell">
                    <div class="itemCell_Left">
                        <span class="color-gray mr-10">{{history?.history?.list?.[pindex]?.created_at || ''}}</span>
                        <a-tag color="var(--opacity-gray)">
                            <span class="color-black" v-if="history?.history?.list?.[pindex]?.ttype===1">{{ $t('futures.market_order') }}</span>
                            <span class="color-black" v-if="history?.history?.list?.[pindex]?.ttype===2">{{ $t('futures.limit_order') }}</span>
                            <span class="color-black" v-if="history?.history?.list?.[pindex]?.ttype===3">{{ $t('futures.conditional_order') }}</span>
                        </a-tag>
                    </div>
                </div>
                <div class="itemCell">
                    <span class="color-gray mr-10">{{ $t('futures.avg_price_order_price') }}</span>
                    <span class="color-black">{{$util.thousandSeparator(history?.history?.list?.[pindex]?.t_price || 0)}}/{{$util.float(history?.history?.list?.[pindex]?.price || 0)}}</span>
                </div>
                <div class="itemCell">
                    <span class="color-gray mr-10">{{ $t('futures.filled_amount_order_amount') }}</span>
                    <span class="color-black">{{$util.float(history?.history?.list?.[pindex]?.amount || 0)}}/{{$util.float(history?.history?.list?.[pindex]?.amount || 0)}}</span>
                </div>
                <div class="itemCell">
                    <span class="color-gray mr-10">{{ $t('futures.fee_usdt') }}</span>
                    <span class="color-black">{{$util.float(history?.history?.list?.[pindex]?.charge || 0)}}</span>
                </div>
                <div class="itemCell">
                    <span class="color-gray mr-10">{{ $t('futures.pnl_usdt') }}</span>
                    <span class="color-black">{{$util.thousandSeparator(history?.history?.list?.[pindex]?.profit || 0)}}</span>
                </div>
                <div class="itemCell">
                    <span class="color-gray mr-10">{{ $t('futures.order_id') }}</span>
                    <div class="itemCell_Right">
                        <span class="mr-5 color-black">{{history?.history?.list?.[pindex]?.id || ''}}</span>
                        <icon-copy size="20" class="color-gray"/>
                    </div>
                </div>
                <div class="cardBox" v-if="history?.history?.list?.[pindex]?.amount > 0">
                    <div class="itemCell">
                        <span class="title color-black">{{ $t('futures.transaction_record') }}</span>
                    </div>
                    <div class="itemCell">
                        <span class="color-gray">{{ $t('futures.avg_price') }}</span>
                        <span class="color-black">{{$util.thousandSeparator(history?.history?.list?.[pindex]?.t_price || 0)}}</span>
                    </div>
                    <div class="itemCell" v-if="history?.history?.list?.[pindex]?.type <= 2">
                        <span class="color-gray">{{ $t('futures.open_price') }}</span>
                        <span class="color-black">{{$util.thousandSeparator(history?.history?.list?.[pindex]?.price || 0)}}</span>
                    </div>
                    <div class="itemCell">
                        <span class="color-gray">{{ $t('futures.filled_amount') }}({{history?.history?.list?.[pindex]?.symbol || 'BTC'}})</span>
                        <span class="color-black">{{$util.float(history?.history?.list?.[pindex]?.amount || 0)}}</span>
                    </div>
                    <div class="itemCell">
                        <span class="color-gray">{{ $t('futures.fee_usdt') }}/{{ $t('futures.type') }}</span>
                        <span class="color-black">{{$util.thousandSeparator(history?.history?.list?.[pindex]?.charge || 0)}}/taker</span>
                    </div>
                    <div class="itemCell">
                        <span class="color-gray">{{ $t('futures.pnl_usdt') }}</span>
                        <span class="color-black">{{$util.thousandSeparator(history?.history?.list?.[pindex]?.profit || 0)}}</span>
                    </div>
                    <div class="itemCell">
                        <span class="color-gray">{{ $t('futures.transaction_time') }}</span>
                        <span class="color-black">{{history?.history?.list?.[pindex]?.created_at || ''}}</span>
                    </div>
                </div>
            </div>
        </a-modal>
        <!--    设置-->
        <a-drawer :width="340"
                  :footer="false"
                  :header="false"
                  :drawer-style="{background: 'var(--background-primary)'}"
                  :visible="settingDrawer"
                  @ok="settingDrawer = false"
                  @cancel="settingDrawer = false"
                  unmountOnClose>
            <div class="settingDrawer">
                <div class="titleBox">
                    <span>{{ $t('futures.settings') }}</span>
                    <icon-close class="color-black cursor" size="20" @click="settingDrawer = false"/>
                </div>
                <div class="label">
                    <p class="color-gray mb-5">{{ $t('futures.position_type') }}</p>
                    <p class="color-primary mb-5">
                        <icon-exclamation-polygon-fill/>
                        {{ $t('futures.cannot_change_position_type') }}
                    </p>
                    <a-radio-group class="radioGroup">
                        <a-radio value="1">
                            <template #radio="{ checked }">
                                <div class="radioItem">
                                    <div class="radio" :class="{'radio-checked': checked}"></div>
                                    <div class="info">
                                        <p>{{ $t('futures.one_way_position') }}</p>
                                        <p class="desc">{{ $t('futures.one_way_position_desc') }}</p>
                                    </div>
                                </div>
                            </template>
                        </a-radio>
                        <a-radio value="2">
                            <template #radio="{ checked }">
                                <div class="radioItem">
                                    <div class="radio" :class="{'radio-checked': checked}"></div>
                                    <div class="info">
                                        <p>{{ $t('futures.two_way_position') }}</p>
                                        <p class="desc">
                                            {{ $t('futures.two_way_position_desc') }}</p>
                                    </div>
                                </div>
                            </template>
                        </a-radio>
                    </a-radio-group>
                </div>
                <div class="label">
                    <p class="color-gray title dotted mb-5">
                        {{ $t('futures.conditional_order_validity') }}
                        <a-tooltip position="top" background-color="var(--tooltip-bg)">
                            <icon-question-circle-fill class="color-gray cursor" size="14"/>
                            <template #content>
                                <p class="font-12 color-always-white">
                                    {{ $t('futures.conditional_order_tip') }}
                                </p>
                            </template>
                        </a-tooltip>
                    </p>
                    <a-radio-group class="radioGroup" mode="row">
                        <a-radio value="1">
                            <template #radio="{ checked }">
                                <div class="radioItem">
                                    <div class="radio" :class="{'radio-checked': checked}"></div>
                                    <div class="info">
                                        <p>24H</p>
                                    </div>
                                </div>
                            </template>
                        </a-radio>
                        <a-radio value="2">
                            <template #radio="{ checked }">
                                <div class="radioItem">
                                    <div class="radio" :class="{'radio-checked': checked}"></div>
                                    <div class="info">
                                        <p>{{ $t('futures.seven_days') }}</p>
                                    </div>
                                </div>
                            </template>
                        </a-radio>
                        <a-radio value="3">
                            <template #radio="{ checked }">
                                <div class="radioItem">
                                    <div class="radio" :class="{'radio-checked': checked}"></div>
                                    <div class="info">
                                        <p>{{ $t('futures.fourteen_days') }}</p>
                                    </div>
                                </div>
                            </template>
                        </a-radio>
                        <a-radio value="4">
                            <template #radio="{ checked }">
                                <div class="radioItem">
                                    <div class="radio" :class="{'radio-checked': checked}"></div>
                                    <div class="info">
                                        <p>{{ $t('futures.thirty_days') }}</p>
                                    </div>
                                </div>
                            </template>
                        </a-radio>
                    </a-radio-group>
                </div>
                <div class="label">
                    <p class="color-gray title mb-5">
                        {{ $t('futures.order_settings') }}
                    </p>
                    <div class="flex align-center jus-bet">
                        <span>{{ $t('futures.order_secondary_confirmation') }}</span>
                        <a-switch/>
                    </div>
                </div>
            </div>
        </a-drawer>
    </a-layout>
</template>
<script>
import service from './service';

export default service;
</script>

<style lang="scss" scoped>
@import "./futures.scss";
</style>
